<template>
  <div class="page-content">
    <page-template
      ref="goodsInfo"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :detailColumns="detailColumns"
    >
    </page-template>
    <el-dialog title="一品多码" :visible.sync="dialogBarCode" center :close-on-click-modal="false"
               custom-class="barCodeDialog" @close="closeDialog">
      <div class="setCode">
        <div class="button">
          商品附加码：
          <el-input v-model="productCode" :maxlength="32"></el-input>
          <el-button type="primary" @click="add()" style="margin-left:8px;" :disabled="btnbool1">添加</el-button>
          <!--          <el-button type="primary" @click="finished()">删除条形码</el-button>-->
        </div>
        <!--        <table-template :tableData="tableData" :tableOptions="multiTableOptions" :toolConfig="MultiCodeConfig" ref="goodsCode">-->
        <!--        </table-template>-->
        <div>
          <el-table :data="codeTableData" :cell-style="{height: '40px'}">
            <el-table-column label="序号" type="index" width="175" :index="(index) => { return index + 1}"
                             align="center"></el-table-column>
            <el-table-column label="附加码" prop="code" align="center"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span style="color: rgb(69, 140, 255); cursor: pointer" @click="deleteMultiCode(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="barCodeSize"
            :current-page="currentBarCodePageNo"
            @size-change="(val) => { barCodeSize = size}"
            @current-change="changeBarCodePage"
            :page-sizes="[10, 20, 50, 100]"
            layout="prev, pager, next"
            :total="barCodeTotal">
          </el-pagination>
        </div>
        <div class="button" style="justify-content: center;margin-top:10px;">
          <el-button @click="dialogBarCode = false" type="primary">完成</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="设置小包装商品" :visible.sync="dialogGoods" center width="800px" class="setGoods">
      <el-form ref="form" :model="form" label-width="80px">
        <div class="inputsearch">
          <div class="searc">商品条码
            <el-input v-model="packageGoodsCode" placeholder="请输入商品条码" v-on:blur="getMinMes()"></el-input>
          </div>
          <div class="searc"> 商品名称
            <el-input v-model="packageGoodsName" placeholder="请输入商品名称" disabled></el-input>
          </div>
          <div class="searc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;单位
            <el-select v-model="value" disabled>
              <el-option v-for="(v,i) in newitem" :key=i :value="v"></el-option>
            </el-select>
          </div>
          <div class="searc">商品售价
            <el-input v-model="packageGoodsPrice" placeholder="请输入商品售价" disabled></el-input>
          </div>
          <div class="searc">成分数量
            <el-input v-model="packageGoodsCount" placeholder="请输入成分数量"
                      oninput="value=value.replace(/[^\d.]/g,'')"></el-input>&nbsp;&nbsp;<el-button
              @click="minadd()" :disabled="btnbool2">增加
            </el-button>
          </div>
        </div>
        <div class="little-data">
          <list-operation ref="listOperation" :tableOptions="minColumns"></list-operation>
          <img src="../../../assets/images/kaifa.jpg" alt="">
        </div>
        <el-form-item style="text-align:center;margin-top:20px">
          <el-button type="primary" @click="submitForm()">提交</el-button>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="设置水果分级" :visible.sync="dialogFruit" center width="800px">
      <el-form ref="form" :model="form" label-width="80px">
        <div class="inputsearch">
          <div class="searc">商品条码
            <el-input v-model="fruitCode" placeholder="请输入商品条码" v-on:blur="getFruitMes()"></el-input>
          </div>
          <div class="searc"> 商品名称
            <el-input v-model="fruitName" placeholder="请输入商品名称" disabled></el-input>
          </div>
          <div class="searc">商品售价
            <el-input v-model="fruitPrice" placeholder="请输入商品售价" disabled></el-input>
          </div>
          <div class="searc">成分数量
            <el-input v-model="fruitCount" placeholder="请输入成分数量" oninput="value=value.replace(/[^\d.]/g,'')"></el-input>&nbsp;&nbsp;<el-button
              @click="fruitadd()" :disabled="btnbool3">增加
            </el-button>
          </div>
        </div>
        <div class="little-data">
          <list-operation ref="listOperation" :tableOptions="fruitColumns"></list-operation>
          <img src="../../../assets/images/kaifa.jpg" alt="">
        </div>
        <el-form-item style="text-align:center;margin-top:20px">
          <el-button type="primary" @click="submitForm()">提交</el-button>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="设置生鲜分割" :visible.sync="dialogFresh" center width="800px">
      <el-form ref="form" :model="form" label-width="80px">
        <div class="inputsearch">
          <div class="searc">商品条码
            <el-input v-model="freshCode" placeholder="请输入商品条码" v-on:blur="getFreshMes()"></el-input>
          </div>
          <div class="searc"> 商品名称
            <el-input v-model="freshName" placeholder="请输入商品名称" disabled></el-input>
          </div>
          <div class="searc">商品售价
            <el-input v-model="freshPrice" placeholder="请输入商品售价" disabled></el-input>
          </div>
          <div class="searc">成分数量
            <el-input v-model="freshCount" placeholder="请输入成分数量" oninput="value=value.replace(/[^\d.]/g,'')"></el-input>&nbsp;&nbsp;<el-button
              @click="freshadd()" :disabled="btnbool4">增加
            </el-button>
          </div>
        </div>
        <div class="little-data">
          <list-operation ref="listOperation" :tableOptions="freshColumns"></list-operation>
          <img src="../../../assets/images/kaifa.jpg" alt="">
        </div>
        <el-form-item style="text-align:center;margin-top:20px">
          <el-button type="primary" @click="submitForm()">提交</el-button>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--    <el-dialog title="同步商品" :visible.sync="listShow" width="1200px" height="800" @close="closeDialog"-->
    <!--               :close-on-click-modal="false">-->
    <!--      <goods-sync ref="goodsSync" v-if="listShow" :isSelect="goodListSelect"-->
    <!--                  :tableOptions="syncTableOptions"></goods-sync>-->
    <!--    </el-dialog>-->
    <add-form ref="addForm" @submit="changeGoodsSubmit"></add-form>
    <el-dialog title="规格设置"
               :visible.sync="specsDialog"
               center
               :close-on-click-modal="false"
               width="1000px"
               height="800px"
    >
      <!--弹窗需要关闭:show-close="false"-->
      <el-alert
        title="请在设置完成之后，在‘商品档案’界面点击‘提交’后生效"
        type="warning"
        :closable="false">
      </el-alert>
      <specs-info ref="specsInfo" v-if="specsDialog" :specsDialog="specsDialog" :specsRow="specsRow"
                  :specsForm="specsForm" @submitSuccess="submitSuccess" @requestSubmit="requestSubmit"></specs-info>
      <!--      <specs-info ref="specsInfo" v-if="dialogTitle === '编辑'?specsDialog:addInfoShow" :specsDialog="specsDialog" :specsRow="specsRow" @submitSuccess="submitSuccess"></specs-info>-->
    </el-dialog>
    <el-dialog title="批量新增" :visible.sync="batchAddShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <div class="batchAdd">
        <batch-add ref="listOperation" :tableOptions="goodsAddColumns"></batch-add>
      </div>
      <div class="btn-box">
        <el-button @click="selectSubmit" type="primary">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分店价格" :visible.sync="showBox" width="1000px" height="2000px" :close-on-click-modal="false">
      <list-template :tableOptions="branchPriceListColumns" :tableData="branchPriceTableData"
                     ref="cashierReportListOperation">
      </list-template>
    </el-dialog>
    <el-dialog :title='dialogTitle+"商品档案"' :visible.sync="addInfoShow" width="1000px" height="800"
               @close="closeDialogAdd" :close-on-click-modal="false" class="add-form">
      <div class="form-flex">
        <el-form ref="addForm" :model="addForm" :rules="rules" class="steps-form" label-width="100px"
                 :show-message="true">
          <div v-show="currentStep === 0">
            <el-steps :active="currentStep" align-center style="padding-bottom:20px" class="cus-steps">
              <el-step title="基础信息"></el-step>
              <el-step @click.native="shopInfo" title="商城信息"></el-step>
              <el-step @click.native="moreInfo" title="更多信息"></el-step>
            </el-steps>
            <div>
              <el-col :span="12">
                <el-form-item label='条码' prop="barCode">
                  <el-input v-model.trim="addForm.barCode" :maxlength="32" @change="checkCodeRepeat('barCode')"
                            placeholder='条码不能为空'
                            :disabled="isEditCode"></el-input>
                  <el-button type="primary" @click="getCode" v-if="!isEditCode">自动生成</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='自编码' prop="artNo">
                  <el-input v-model.trim="addForm.artNo" :maxlength="32" @change="checkCodeRepeat('artNo')"
                            placeholder='请输入'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='商品名称' prop="name">
                  <el-input v-model.trim="addForm.name" placeholder='请输入' :maxlength="32"
                            @change="checkName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='简称' prop="goodsAbbreviate">
                  <el-input v-model.trim="addForm.goodsAbbreviate" :maxlength="10" placeholder='请输入简称'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='商品类别' prop="goodsCategoryId">
                  <el-cascader
                    :show-all-levels="false"
                    v-model="addForm.goodsCategoryId"
                    :options="goodsCategoryList"
                    :props="{ checkStrictly: true,emitPath:false }"
                    clearable></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='助记码' prop="mnemonicCode">
                  <el-input v-model.trim="addForm.mnemonicCode" :maxlength="10" placeholder='请输入助记码'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='供应商' prop="supplierId">
                  <el-select v-model="addForm.supplierId" placeholder="请选择" @change="changeSupplier" filterable>
                    <el-option
                      v-for="(item,index) in supplierList"
                      :key="index"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='品牌' prop="goodsBrandId">
                  <el-select v-model="addForm.goodsBrandId" placeholder="请选择" filterable>
                    <el-option
                      v-for="(item,index) in brandList"
                      :key="index"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="isEdit?24:12">
                <el-form-item label='联营扣率' prop="jointOperationRate">
                  <el-input type="number" v-model="addForm.jointOperationRate" placeholder=''
                            :disabled="!deductionRate"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="this.isShowinventoryNum">
                <el-form-item label='初始库存' prop="inventoryNum">
                  <el-input-number type="number" :min="0" v-model.trim="addForm.inventoryNum" :max="9999.999"
                                   :precision="3" placeholder='请输入'></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='规格' prop="openSpecs">
                  <!--                  <div style="display: flex;">-->
                  <!--                    <el-radio-group v-model="addForm.openSpecs" style="width: 200px;" @change="changeOpenSpecs" :disabled="isEdit">-->
                  <!--                      <el-radio :label="false">单规格</el-radio>-->
                  <!--                      <el-radio :label="true">多规格</el-radio>-->
                  <!--                    </el-radio-group>-->
                  <el-select v-model="addForm.openSpecs" style="width: 95px;margin-right: 5px;"
                             @change="changeOpenSpecs" :disabled="isEdit">
                    <el-option label="单规格" :value="false"></el-option>
                    <el-option label="多规格" :value="true"></el-option>
                  </el-select>
                  <el-input v-if="!addForm.openSpecs" v-model="addForm.specs" :maxlength="16" placeholder='输入商品规格'
                            style="width: 95px;"></el-input>
                  <el-button v-else type="primary" @click="addSetSpecs">设置多规格</el-button>
                  <!--                  </div>-->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='单位' prop="goodsUnitId">
                  <el-select v-model="addForm.goodsUnitId" placeholder="请选择" filterable>
                    <el-option
                      v-for="(item,index) in unitList"
                      :key="index"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='商品类型' prop="openCombination">
                  <el-select
                    v-model="addForm.openCombination"
                    :style="{width:addForm.openCombination == 0?'200px':'95px',marginRight:'5px'}"
                    :disabled="addForm.openSpecs || isEdit"
                    @change="changeCombination">
                    <el-option
                      v-for="(item,index) of goodsTypeList"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                    <!--                    <el-option label="普通商品" :value="false"></el-option>-->
                    <!--                    <el-option label="组合商品" :value="true"></el-option>-->
                  </el-select>
                  <el-button v-if="addForm.openCombination!== 0" type="primary" @click="setSonGoods">设置子商品</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label='计价方式' prop="pricingMethod">
                  <el-select v-model="addForm.pricingMethod" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in pricingMethodList"
                      :key="index"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label='毛利率'>
                  <!--                  ((row.retailPrice - row.buyPrice)/row.retailPrice).toFixed(4)-->
                  <el-input type="number" :min="0"
                            v-model="((addForm.retailPrice-addForm.buyPrice)/addForm.retailPrice).toFixed(4)"
                            placeholder='0.0000' disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='进货价' prop="buyPrice">
                  <el-input-number v-model.trim="addForm.buyPrice" placeholder='请输入' :max="99999.99" :precision="2"
                                   :disabled="isEditPrice" @change="changeBuyPrice"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='零售价' prop="retailPrice">
                  <el-input-number type="number" v-model.trim="addForm.retailPrice" :max="99999.99" placeholder='请输入'
                                   :precision="2"
                                   :disabled="isEditPrice" @change="changeRetailPrice"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='批发价' prop="tradePrice">
                  <el-input-number type="number" v-model.trim="addForm.tradePrice" :max="99999.99" placeholder='请输入'
                                   :precision="2"
                                   :disabled="isEditPrice"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='会员价' prop="vipPrice">
                  <el-input-number type="number" v-model.trim="addForm.vipPrice" :max="99999.99" placeholder='请输入'
                                   :precision="2"
                                   :disabled="isEditPrice" @change="changeVipPrice"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='配送价' prop="deliveryPrice">
                  <el-input-number type="number" v-model.trim="addForm.deliveryPrice" :max="99999.99" placeholder='请输入'
                                   :precision="2"
                                   :disabled="isEditPrice"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='最低售价' prop="lowestPrice">
                  <el-input-number type="number" v-model.trim="addForm.lowestPrice" :max="99999.99" placeholder='请输入'
                                   :precision="2"
                                   :disabled="isEditPrice" @change="changeLowerPrice"></el-input-number>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="12">-->
              <!--                <el-form-item label='进货规格' prop="buySpecs">-->
              <!--                  <el-input type="number" v-model.trim="addForm.buySpecs" placeholder='请输入'></el-input>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->

            </div>
          </div>
          <div v-show="currentStep === 1">
            <el-steps :active="currentStep" align-center style="padding-bottom:20px" class="cus-steps">
              <el-step @click.native="basisInfo" title="基础信息"></el-step>
              <el-step title="商城信息"></el-step>
              <el-step @click.native="moreInfo" title="更多信息"></el-step>
            </el-steps>
            <div>
              <el-col :span="24">
                <el-form-item label='商城销售' prop="openMall">
                  <el-switch v-model.trim="addForm.openMall" active-text="开" inactive-text="关"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='商城零售价' prop="mallRetailPrice">
                  <el-input-number type="number" :precision="2" :max="99999.99" v-model.trim="addForm.mallRetailPrice"
                                   placeholder='请输入'
                                   :disabled="isEditPrice" @change="changeMallRetail"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='商城会员价' prop="mallVipPrice">
                  <el-input-number type="number" :precision="2" v-model.trim="addForm.mallVipPrice" :max="99999.99"
                                   placeholder='请输入'
                                   :disabled="isEditPrice" @change="changeMallVip"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='商城PLUS价' prop="mallPlusVipPrice">
                  <el-input-number type="number" :precision="2" :max="99999.99" v-model.trim="addForm.mallPlusVipPrice"
                                   placeholder='请输入' :disabled="isEditPrice"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='商城最低价' prop="mallLowestPrice">
                  <el-input-number type="number" :precision="2" v-model.trim="addForm.mallLowestPrice" :max="99999.99"
                                   placeholder='请输入'
                                   :disabled="isEditPrice" @change="changeMallLower"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='封面图' prop="goodsImageUrl">
                  <file-template
                    v-if="addInfoShow"
                    ref="goodsImageUrl"
                    :column="{prop:'goodsImageUrl',limit: 1, change: this.setImageData}"
                  ></file-template>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='图片链接' prop="onlineImgUrl">
                  <el-input v-model.trim="addForm.onlineImgUrl" :maxlength="512" placeholder='请输入图片链接'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label='商品主图' prop="onlineImgMapList">
                  <file-template
                    v-if="addInfoShow"
                    ref="onlineImgMapList"
                    :column="{prop:'onlineImgMapList',limit: 5, change: this.setImageOnline1}"
                  ></file-template>
                </el-form-item>
              </el-col>
            </div>
          </div>
          <div v-show="currentStep === 2">
            <el-steps :active="currentStep" align-center style="padding-bottom:20px" class="cus-steps">
              <el-step @click.native="basisInfo" title="基础信息"></el-step>
              <el-step @click.native="shopInfo" title="商城信息"></el-step>
              <el-step title="更多信息"></el-step>
            </el-steps>
            <div>
              <el-col :span="12">
                <el-form-item label='产地' prop="placeOrigin">
                  <el-input v-model.trim="addForm.placeOrigin" :maxlength="16" placeholder='请输入'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='等级' prop="goodsLevel">
                  <el-input v-model.trim="addForm.goodsLevel" :maxlength="16" placeholder='请输入'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='采购周期' prop="purchaseCycle">
                  <el-input v-model.trim="addForm.purchaseCycle" :maxlength="16" placeholder='请输入'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='商品状态' prop="status">
                  <el-select v-model="addForm.status" :disabled="isEdit" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in statusList"
                      :key="index"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='提成方式' prop="guiderCommissionType">
                  <el-select v-model="addForm.guiderCommissionType" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in guiderTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="addForm.guiderCommissionType === 20">
                <el-form-item label='提成率' prop="commissionPercentage">
                  <!--                  <el-input type="number" v-model.trim="addForm.commissionPercentage" placeholder='请输入' @change="changeCommissionRate"></el-input>-->
                  <el-input-number
                    style="text-align: left;padding:0;"
                    :precision="4"
                    v-model.trim="addForm.commissionPercentage"
                    :min='0'
                    :max="1"
                    @change="changeCommissionRate"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-show="addForm.guiderCommissionType === 30">
                <el-form-item label='提成金额' prop="commissionMoney">
                  <el-input type="number" :min="0" :max="99999.99" v-model.trim="addForm.commissionMoney"
                            placeholder='请输入'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='库存低位' prop="lowInventory">
                  <el-input-number type="number" v-model.trim="addForm.lowInventory" :max="9999.999" :precision="3"
                                   placeholder='请输入'></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='库存高位' prop="highInventory">
                  <el-input-number type="number" v-model.trim="addForm.highInventory" :precision="3" :max="9999.999"
                                   placeholder='请输入'></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='保质期' prop="qualityGuaranteePeriod">
                  <el-input v-model.trim="addForm.qualityGuaranteePeriod" :maxlength="16" placeholder='请输入'></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='厂家指导价' prop="guidePrice">
                  <el-input-number type="number" :min="0" v-model.trim="addForm.guidePrice" :max="99999.99"
                                   :precision="2" placeholder='0.00'></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='管理库存' prop="openInventory">
                  <el-switch v-model="addForm.openInventory" active-text="开" inactive-text="关"
                             @change="changeOpenInventory"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='允许议价' prop="bargaining">
                  <el-switch v-model="addForm.bargaining" active-text="开" inactive-text="关"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='允许赠送' prop="give">
                  <el-switch v-model="addForm.give" active-text="开" inactive-text="关"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label='允许折扣' prop="offlineDiscount">
                  <el-switch v-model="addForm.offlineDiscount" active-text="开" inactive-text="关"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="!this.$utils.getSysUser().storeId">
                <el-form-item label='是否同步门店' prop="syncStore">
                  <el-switch v-model="addForm.syncStore" active-text="开" inactive-text="关" :disabled="isEdit"
                             @change="isSyncStore"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="addForm.syncStore && !this.$utils.getSysUser().storeId">
                <el-form-item label='门店' prop="storeLists">
                  <el-select v-model="addForm.storeLists" placeholder="请选择" multiple collapse-tags @change="changeStore"
                             @remove-tag="removeTag">
                    <el-checkbox class="store-checkbox" v-model="storeChecked" @change='selectAll' :disabled="isEdit">
                      全部门店
                    </el-checkbox>
                    <!--                    <el-option label='全部门店' value='全部门店' @click.native='selectAll'></el-option>-->
                    <el-option
                      v-for="(item,index) in storeList"
                      :key="index"
                      :label="item.name"
                      :disabled="isEdit"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </div>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handdlePre" v-if="currentStep != 0">上一步</el-button>
          <el-button type="primary" @click="handdleNext" v-if="currentStep != 2">下一步</el-button>
          <el-button type="primary" @click="save" :disabled="disabled">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <!--选择商品弹框-->
    <el-dialog title="商品列表"
               :visible.sync="goodsListShow"
               width="1200px"
               height="900"
               :close-on-click-modal="false"
               class="add-form"
    >
      <good-list
        v-if="goodsListShow"
        ref="goodsListOperation"
        :isSelect="true"
        @selectSubmit="rowsSelectSubmit"
        :otherParam="otherParam"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <!--组合商品 弹框-->
    <el-dialog title="设置子商品明细"
               :visible.sync="sonListShow"
               width="1000px"
               height="900"
               :show-close="false"
               :close-on-click-modal="false"
               class="add-form"
    >
      <el-alert
        title="请在设置完成之后，在‘商品档案’界面点击‘提交’后生效"
        type="warning"
        :closable="false">
      </el-alert>
      <el-button type="primary" @click="showSonGoodsList" style="margin: 10px 0">新增子商品</el-button>
      <list-operation v-if="sonListShow" ref="listOperation" :tableOptions="sonListColumns"></list-operation>
      <div style="text-align: center;">
        <el-button type="primary" @click="saveSonList" style="margin: 10px 0;">保存</el-button>
      </div>
    </el-dialog>
    <!--    多规格详情-->
    <el-dialog title="规格详情"
               :visible.sync="specsDetailShow"
               width="1000px"
               height="2000px"
               :close-on-click-modal="false"
    >
      <more-table
        v-if="specsDetailShow"
        ref="specsDetailColumns"
        :tableColumns="specsDetailColumns"
        :data="specsDetailData"
      >
      </more-table>
    </el-dialog>
    <!--    批量修改-->
    <el-dialog title='批量修改' :visible.sync="batchShow" width="1000px" height="800" @close="closeBatch"
               :close-on-click-modal="false" class="batch-form">
      <el-form ref="batchForm" :model="batchForm" label-width="100px" :show-message="false" :rules="batchRules">
        <el-row style="padding:0 20px;">
          <el-checkbox-group v-model="batchList" class="checkbox-style" @change="changeBatch">
            <el-col :span="12">
              <el-checkbox label="goodsCategoryId" @change="changeBatchItem($event,'goodsCategoryId')">{{ '' }}
              </el-checkbox>
              <el-form-item label='商品类别' prop="goodsCategoryId" aria-placeholder="请选择">
                <el-cascader
                  :show-all-levels="false"
                  v-model="batchForm.goodsCategoryId"
                  :options="goodsCategoryList"
                  :props="{ checkStrictly: true,emitPath:false }"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="goodsBrandId" @change="changeBatchItem($event,'goodsBrandId')">{{ '' }}</el-checkbox>
              <el-form-item label='品牌' prop="goodsBrandId">
                <el-select v-model="batchForm.goodsBrandId" placeholder="请选择" filterable>
                  <el-option
                    v-for="(item,index) in brandList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="goodsUnitId" @change="changeBatchItem($event,'goodsUnitId')">{{ '' }}</el-checkbox>
              <el-form-item label='单位' prop="goodsUnitId">
                <el-select v-model="batchForm.goodsUnitId" placeholder="请选择" filterable>
                  <el-option
                    v-for="(item,index) in unitList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="pricingMethod">{{ '' }}</el-checkbox>
              <el-form-item label='计价方式' prop="pricingMethod">
                <el-select v-model="batchForm.pricingMethod" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in pricingMethodList"
                    :key="index"
                    :label="item.label"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-checkbox label="guiderCommissionType" @change="changeBatchItem($event,'guiderCommissionType')">
                {{ '' }}
              </el-checkbox>
              <div style="display: flex;">
                <el-form-item label='提成方式' prop="guiderCommissionType" class="form-item-select">
                  <el-select v-model="batchForm.guiderCommissionType" placeholder="请选择" @change="changeGuider">
                    <el-option
                      v-for="(item,index) in guiderTypeList"
                      :key="index"
                      :label="item.label"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label='提成率' prop="commissionPercentage" v-if="batchForm.guiderCommissionType === 20"
                              label-width="80px">
                  <!--                  <el-input type="number" v-model.trim="batchForm.commissionPercentage" placeholder='请输入' :min="0" :max="1" style="width:100px;"></el-input>-->
                  <el-input-number
                    style="width:100px;"
                    :precision="4"
                    v-model.trim="batchForm.commissionPercentage"
                    :min='0'
                    :max="1"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label='提成金额' prop="commissionMoney" v-if="batchForm.guiderCommissionType === 30"
                              label-width="80px">
                  <el-input type="number" v-model.trim="batchForm.commissionMoney" placeholder='请输入' :min="0"
                            style="width:100px;"></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="12">
              <el-checkbox label="placeOrigin" @change="changeBatchItem($event,'placeOrigin')">{{ '' }}</el-checkbox>
              <el-form-item label='产地' prop="placeOrigin">
                <el-input v-model.trim="batchForm.placeOrigin" placeholder='请输入'></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="goodsLevel" @change="changeBatchItem($event,'goodsLevel')">{{ '' }}</el-checkbox>
              <el-form-item label='等级' prop="goodsLevel">
                <el-input v-model.trim="batchForm.goodsLevel" placeholder='请输入'></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="purchaseCycle" @change="changeBatchItem($event,'purchaseCycle')">{{ '' }}
              </el-checkbox>
              <el-form-item label='采购周期' prop="purchaseCycle">
                <el-input v-model.trim="batchForm.purchaseCycle" placeholder='请输入'></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="qualityGuaranteePeriod" @change="changeBatchItem($event,'qualityGuaranteePeriod')">
                {{ '' }}
              </el-checkbox>
              <el-form-item label='保质期' prop="qualityGuaranteePeriod">
                <el-input v-model.trim="batchForm.qualityGuaranteePeriod" placeholder='请输入'></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="lowInventory" @change="changeBatchItem($event,'lowInventory')">{{ '' }}</el-checkbox>
              <el-form-item label='库存低位' prop="lowInventory">
                <el-input type="number" v-model.trim="batchForm.lowInventory" placeholder='请输入'></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="highInventory" @change="changeBatchItem($event,'highInventory')">{{ '' }}
              </el-checkbox>
              <el-form-item label='库存高位' prop="highInventory">
                <el-input type="number" v-model.trim="batchForm.highInventory" placeholder='请输入'></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="openInventory">{{ '' }}</el-checkbox>
              <el-form-item label='管理库存' prop="openInventory">
                <el-switch v-model="batchForm.openInventory" active-text="开" inactive-text="关"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="bargaining">{{ '' }}</el-checkbox>
              <el-form-item label='允许议价' prop="bargaining">
                <el-switch v-model="batchForm.bargaining" active-text="开" inactive-text="关"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="give">{{ '' }}</el-checkbox>
              <el-form-item label='允许赠送' prop="give">
                <el-switch v-model="batchForm.give" active-text="开" inactive-text="关"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-checkbox label="offlineDiscount">{{ '' }}</el-checkbox>
              <el-form-item label='允许折扣' prop="offlineDiscount">
                <el-switch v-model="batchForm.offlineDiscount" active-text="开" inactive-text="关"></el-switch>
              </el-form-item>
            </el-col>
          </el-checkbox-group>
        </el-row>
        <div class="dialog-footer" style="padding-top: 20px">
          <el-button type="primary" @click="saveBatch">提交</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--  同步商品新弹窗  -->
    <el-dialog title="同步商品" :visible.sync="listShow" width="970px" center
               @close="syncStep=0;updateStep=0;updateOperationRecordId='';storeId ='';operationRecordId= '';"
               :close-on-click-modal="false">
      <div class="syncGoods">
        <el-tabs type="border-card" @tab-click="storeId = ''">
          <el-tab-pane label="同步新商品">
            <div v-if="syncStep == 0 ">
              <div style="height:400px;">
                <div class="info-text">新商品指在总部机构存在，在门店不存在的商品。</div>
                <div style="margin-top:20px;display: flex;align-items: center;">
                  <div style="margin-right: 10px">同步给:</div>
                  <div>
                    <el-select v-model="storeId" placeholder="请选择门店">
                      <el-option
                        v-for="item in shopList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div style="margin-top:20px;">
                共选中<span style="color:#E65858;">{{ selectProduct }}条</span>商品
              </div>
              <div style="display: flex;justify-content: center;">
                <el-button @click.prevent="listShow = false;storeId = ''">取消</el-button>
                <el-button @click.p.prevent="syncShop" type="primary">确定</el-button>
              </div>
            </div>
            <div v-if="syncStep == 1" style="height:400px;text-align: center;padding-top:110px;">
              <i style="font-size: 48px" class="el-icon-loading"></i>
              <div
                style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 300;color: #999999;margin-top:12px;">
                正在同步
              </div>
            </div>
            <div v-if="syncStep == 2" style="height:400px;">
              <!-- 有问题按键-->
              <el-button v-if="isShowSyncInsertDetail" type="primary" style="width: 100%;height:40px;margin-top:50px;"
                         @click.prevent="syncStep = 3;getResult(operationRecordId)">查看详情
              </el-button>
              <div v-if="!operationRecordId" style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
                <div>
                  <i style="font-size: 64px;color:#FF553E" class="el-icon-circle-close"></i>
                </div>
                <span style="margin-top:12px;color:#FF553E;">导入结束</span>
              </div>
              <div v-if="importStatus" style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
                <div>
                  <i style="font-size: 64px;color:#458CFF" class="el-icon-circle-check"></i>
                </div>
                <span style="margin-top:12px;">导入成功！</span>
              </div>
            </div>
            <div v-if="syncStep == 3">
              <div
                style="margin-bottom:27px;padding:11px 14px;font-weight: 300;color: #FF553E; width: 100%;background: #FFF6F4;border-radius: 4px;">
                <i class="el-icon-circle-close"></i>
                同步失败{{ errorCount }}条商品
              </div>
              <el-table :data="errorData" :cell-style="{height:'40px' }" width="100%"
                        :header-cell-style="{height: '40px'}">
                <el-table-column label="序号" type="index" :index="(index) => { return index + 1}"
                                 align="center"></el-table-column>
                <el-table-column label="条码" align="center" prop="barCode"></el-table-column>
                <el-table-column label="异常原因" align="center" prop="remarks"></el-table-column>
              </el-table>
              <el-pagination
                style="margin-top:15px"
                background
                :page-size="10"
                :current-page="errPageNo"
                @current-change="(val) =>{getResult({pageNumber: val })}"
                layout="prev, pager, next"
                :total="errorCount">
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="更新商品信息" style="border-radius: 4px">
            <div v-if="updateStep == 0">
              <div style="height: 400px;">
                <div style="display: flex;align-items: center;">
                  <div style="margin-right: 10px">更新门店:</div>
                  <el-select v-model="storeId" placeholder="请选择门店">
                    <el-option
                      v-for="item in shopList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div style="margin-top:28px;">
                  <div style="margin-bottom:20px;">更新字段：</div>
                  <el-checkbox-group v-model="goodsList">
                    <el-checkbox style="margin-bottom:20px;" v-for="(label, index) in labelList" :label="label.value"
                                 :key="index">{{ label.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>

              </div>
              <div style="margin-top:20px;">
                共选中<span style="color:#E65858;">{{ selectProduct }}条</span>商品
              </div>
              <div style="display: flex;justify-content: center;margin-top:30px">
                <el-button @click.prevent="() => {listShow = false; storeId=''; goodsList = []}">取消</el-button>
                <el-button @click.p.prevent="syncColumnList" :loading="confirm" type="primary">确定</el-button>
              </div>
            </div>
            <div v-if="updateStep == 1" style="height:400px;text-align: center;padding-top:110px;">
              <i style="font-size: 48px" class="el-icon-loading"></i>
              <div
                style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 300;color: #999999;margin-top:12px;">
                正在更新
              </div>
            </div>
            <div v-if="updateStep == 2" style="height:400px;">
              <!-- 有问题按键-->
              <el-button v-if="isShowSyncUpdateDetail" type="primary" style="width: 100%;height:40px;margin-top:50px;"
                         @click.prevent="updateStep = 3;getUpdateResult({operationRecordId: updateOperationRecordId })">
                查看详情
              </el-button>
              <div v-if="!updateOperationRecordId" style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
                <div>
                  <i style="font-size: 64px;color:#FF553E" class="el-icon-circle-close"></i>
                </div>
                <span style="margin-top:12px;color:#FF553E;">更新结束</span>
              </div>
              <div v-if="importUpdateStatus" style="text-align: center;margin-top: 80px;padding-bottom: 40px;">
                <div>
                  <i style="font-size: 64px;color:#458CFF" class="el-icon-circle-check"></i>
                </div>
                <span style="margin-top:12px;">更新完成！</span>
              </div>
            </div>
            <div v-if="updateStep == 3">
              <div
                style="margin-bottom:27px;padding:11px 14px;font-weight: 300;color: #FF553E; width: 100%;background: #FFF6F4;border-radius: 4px;">
                <i class="el-icon-circle-close"></i>
                更新失败{{ errorUpdateCount }}条商品
              </div>
              <el-table :data="errorUpdateData" :cell-style="{height:'40px' }" width="100%"
                        :header-cell-style="{height: '40px'}">
                <el-table-column label="序号" type="index" width="120" :index="(index) => { return index + 1}"
                                 align="center"></el-table-column>
                <el-table-column label="条码" align="center" prop="barCode"></el-table-column>
                <el-table-column label="异常原因" align="center" prop="remarks"></el-table-column>
              </el-table>
              <el-pagination
                background
                :page-size="10"
                :current-page="errUpdatePageNo"
                @current-change="(val) =>{getUpdateResult({pageNumber: val })}"
                layout="prev, pager, next"
                :total="errorUpdateCount">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="importShow" custom-class="importDialog" :close-on-click-modal="false">
      <import-template v-if="importShow" ref="importTemplate" :importShow="importShow" :dataSize="importLength"
                       @importFile="uploadExcel" @downTemplate="downloadTemplate"></import-template>
    </el-dialog>
    <el-dialog title="一键同步" :visible.sync="dialogOneClickSync" center :close-on-click-modal="false"
               custom-class="barCodeDialog" @close="closeDialogOneClickSync">
      <div>
        <div class="fond-style">
          <p style="padding-bottom: 10px">&emsp;&emsp;注释：一键同步功能的开发是为了方便用户添加了门店之后，快速的将商户的商品信息同步至门店，且每个门店该功能只能使用一次，
            在同步过程中会将门店的商品以及库存全部删除，请谨慎使用！</p>
          <p>&emsp;&emsp;同步门店支持多选，且门店数量不能超过5，但同步过的门店将不能被选择</p>
        </div>
      </div>
      <el-table :data="storePageTableData" :cell-style="{height: '40px'}" @selection-change="selectRowsChange">
        <el-table-column type="selection" width="55" :selectable="handleTableSelectStatus"></el-table-column>
        <el-table-column label="序号" type="index" width="175" :index="(index) => { return index + 1}"
                         align="center"></el-table-column>
        <el-table-column label="编码" prop="code" align="center"></el-table-column>
        <el-table-column label="名称" prop="name" align="center"></el-table-column>
        <el-table-column label="门店类型" prop="storeClassName" align="center"></el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="oneClickSyncSize"
        :current-page="currentoneClickSyncSizePageNo"
        @size-change="(val) => { oneClickSyncSize = size}"
        @current-change="changeOneClickSyncPage"
        :page-sizes="[10, 20, 50, 100]"
        layout="prev, pager, next"
        :total="oneClickSyncTotal">
      </el-pagination>

      <div class="button" style="justify-content: center;margin-top:10px;margin-left:40%;">
        <el-button @click="oneClickSyncGoods" type="primary">同步</el-button>
        <el-button @click="closeDialogOneClickSync" type="primary">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import formTemplate from '@/components/template/formTemplate';
  import api from '@/config/api';
  import specsInfo from '@/components/business/specsInfo';
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import listOperation from '@/components/template/listOperation';
  import goodsSync from '@/components/business/goodsSync';
  import batchAdd from '@/components/business/batchAdd'
  import addForm from '@/components/template/add';
  import listTemplate from '@/components/template/listTemplate';
  import fileTemplate from '@/components/controls/fileTemplate';
  import pinyin from 'js-pinyin'// 汉字转首字母
  import goodList from '@/components/business/goodList';
  import moreTable from '@/components/business/moreTable';
  // 导入模版组件
  import importTemplate from '@/components/business/importTemplate';

  export default {

    components: {
      pageTemplate,
      specsInfo,
      searchFormTemplate,
      tableTemplate,
      listOperation,
      goodsSync,
      batchAdd,
      formTemplate,
      addForm,
      listTemplate,
      fileTemplate,
      goodList,
      moreTable,
      importTemplate
    },
    data() {
      var validateCode = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('该值不能为空'))
        }
        // const reg = /[A-Z0-9a-z_-]+$/
        const reg = /^[a-zA-Z0-9-_]+$/;
        setTimeout(() => {
          console.log(reg.test(value))
          if (!reg.test(value)) {
            callback(new Error('请填写正确的格式'))
          } else {
            callback()
          }
        }, 800)
      }
      return {
        loading: false,
        // 是否显示下载模版
        importShow: false, // 显示弹窗
        importLength: 2000,
        // 是否显示初始化库存
        isShowinventoryNum: true,
        barCodeSize: 10,
        oneClickSyncSize: 10,
        updateStep: 0,
        errorUpdateData: [],
        storeRowArray: [],
        errorUpdateCount: 0,
        errUpdatePageNo: 1,
        importUpdateStatus: false,
        errorData: [],
        errorCount: 0,
        errPageNo: 1,
        isShowSyncInsertDetail: false,
        isShowSyncUpdateDetail: false,
        updateOperationRecordId: '',
        operationRecordId: '',
        importStatus: false,
        syncStep: 0,
        barCodeTotal: 0,
        oneClickSyncTotal: 0,
        codeTableData: [],
        storePageTableData: [],
        storeId: '',
        currentBarCodePageNo: 1,
        currentoneClickSyncSizePageNo: 1,
        confirm: false,
        goodsList: [],
        shopList: [],
        labelList: [],
        selectProduct: 0,
        goodsTypeList: [
          {name: '普通商品', id: 0},
          {name: '组合商品', id: 1},
          {name: '自动转货', id: 2}
        ],
        batchList: [],
        batchForm: {
          goodsCategoryId: '', // 类别
          goodsBrandId: '', // 品牌
          goodsUnitId: '', // 单位
          guiderCommissionType: 20, // 提成方式,默认按比例
          commissionPercentage: 0.00, // 提成率
          commissionMoney: '', // 提成金额
          pricingMethod: 10, // 计价方式
          placeOrigin: '', // 产地
          goodsLevel: '', // 等级
          purchaseCycle: '', // 采购周期
          qualityGuaranteePeriod: '', // 保质期
          lowInventory: 0, // 库存低位
          highInventory: 9999, // 库存高位
          openInventory: true, // 是否开启管理库存
          bargaining: true, // 允许议价
          offlineDiscount: true, // 允许折扣
          give: true// 允许赠送
        },
        batchRules: {
          goodsCategoryId: [{required: false, message: '商品类别不能为空', trigger: 'change'}],
          goodsBrandId: [{required: false, message: '商品品牌不能为空', trigger: 'change'}],
          goodsUnitId: [{required: false, message: '单位不能为空', trigger: 'change'}],
          commissionPercentage: [{required: false, message: '提成率不能为空', trigger: 'blur'}],
          commissionMoney: [{required: false, message: '提成金额不能为空', trigger: 'blur'}],
          placeOrigin: [{required: false, message: '产地不能为空', trigger: 'blur'}],
          goodsLevel: [{required: false, message: '等级不能为空', trigger: 'blur'}],
          purchaseCycle: [{required: false, message: '采购周期不能为空', trigger: 'blur'}],
          qualityGuaranteePeriod: [{required: false, message: '保质期不能为空', trigger: 'blur'}],
          lowInventory: [{required: false, message: '库存低位不能为空', trigger: 'blur'}],
          highInventory: [{required: false, message: '库存高位不能为空', trigger: 'blur'}]
        },
        batchShow: false,
        specsDetailData: [],
        specsDetailColumns: [
          {
            label: '规格名称',
            prop: 'specsNameList',
            width: '100',
            align: 'center'
          },
          // {
          //   prop: "specsImageUrl",
          //   label: "规格图片",
          //   align: "center",
          //   type: "image",
          //   width: "100",
          // },
          {
            label: '规格条码',
            prop: 'specsBarCode',
            align: 'center',
            width: '150'
          },
          {
            prop: 'buyPrice',
            label: '进价',
            align: 'center',
            width: '100'
          },
          {
            prop: 'retailPrice',
            label: '零售价',
            align: 'center',
            width: '100'
          },
          {
            prop: 'vipPrice',
            label: '会员价',
            align: 'center',
            width: '100'
          },
          {
            prop: 'mallRetailPrice',
            label: '商城零售价',
            align: 'center',
            width: '100'
          },
          {
            prop: 'mallVipPrice',
            label: '商城会员价',
            align: 'center',
            width: '100'
          },
          {
            prop: 'mallPlusVipPrice',
            label: '商城Plus会员价',
            align: 'center',
            width: '150'
          }
        ],
        specsDetailShow: false,
        disabled: false,
        num: 0,
        sonListShow: false,
        goodsListShow: false,
        sonListColumns: {
          height: '100%',
          summaryColumns: ['goodsNum', 'totalPrice', 'buyPrice'],
          hideSum: true,
          disabled: false,
          indexShow: true, // 是否显示索引
          columns: [
            {label: '操作', type: 'operation', width: '100', prop: 'operation'},
            // {
            //   label: '选择商品',
            //   prop: 'selectGoods',
            //   type: 'more',
            //   callback: this.showSonGoodsList,
            //   width: '90',
            // },
            {
              label: '条码',
              prop: 'barCode',
              type: 'input',
              change: this.queryGoodsByBarCode,
              width: '150'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '150'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '80'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '70'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '100'
            },
            {
              label: '成本价',
              prop: 'purchasePrice',
              width: '100'
            },
            {
              label: '成分数量',
              prop: 'goodsNum',
              width: '100',
              type: 'inputNumber',
              precision: 2,
              defaultValue: 1,
              change: this.numChange
            },
            {
              label: '金额小计',
              prop: 'totalPrice',
              width: '100',
              type: 'inputNumber',
              disabled: true,
              precision: 2,
              defaultChange: this.getTotalPrice
            }
          ]
        },
        otherParam: {openSpecs: false, sonGoodsType: 1},
        listTableData: [],
        storeChecked: true,
        currentStep: 0,
        storeList: [],
        // guiderTypeList:[],
        // statusList:[],
        // pricingMethodList:[],
        // manageTypeList:[],
        goodsCategoryList: [],
        supplierList: [],
        brandList: [],
        unitList: [],
        fileList: [],
        showUpload: false,
        showBox: false,
        showForm: true,
        changeValuePrecision: 0,
        changeValue: '',
        // goodsId:'',
        interval: '',
        value: '',
        form: {},
        newitem: [],
        batchUpDateList: [],
        page: {
          current: 1,
          total: 0,
          pageSize: 10
        },
        btnbool1: true,
        btnbool2: true,
        btnbool3: true,
        btnbool4: true,
        dialogBarCode: false,
        dialogGoods: false,
        dialogFruit: false,
        dialogFresh: false,
        dialogOneClickSync: false,
        listShow: false,
        goodListSelect: true,
        batchAddShow: false,
        goodEditListSelect: false,
        productCode: '',
        packageGoodsCode: '',
        packageGoodsName: '',
        packageGoodsPrice: '',
        packageGoodsCount: '',
        fruitCode: '',
        fruitName: '',
        fruitPrice: '',
        freshCode: '',
        freshName: '',
        freshPrice: '',
        fruitCount: '',
        freshCount: '',
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '商品名称/条码',
              prop: 'otherName',
              type: 'input',
              isFuzzy: true,
              placeholder: '请输入商品名称/条码',
              labelWidth: '110'
            }
          ],
          complex: [
            {
              label: '商品名称/条码',
              prop: 'otherName',
              type: 'input',
              isFuzzy: true,
              placeholder: '请输入商品名称/条码',
              span: 8,
            },
            {label: '商品自编码', prop: 'artNo', span: 8, type: 'input', isFuzzy: true, placeholder: '请输入商品自编码'},
            {
              label: '类别',
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              valueKey: 'value',
              data: [],
              span: 8,
              url: api.archives.getCategoryTree
            },
            {
              label: '品牌',
              type: 'select',
              prop: 'goodsBrandId',
              data: [],
              span: 8
              // url: api.archives.brand
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              data: [],
              span: 8
              // url: api.archives.supplier
            },
            {
              label: '计价方式',
              type: 'select',
              prop: 'pricingMethod',
              span: 8,
              data: this.$utils.getCacheStatus('asGoods.pricingMethod')
            },
            {
              label: '商品类型',
              type: 'select',
              prop: 'openCombination',
              data: [{label: '普通商品', value: 0}, {label: '组合商品', value: 1}],
              change: this.combinationChange,
              span: 8
            },
            {
              prop: 'father',
              hidden: true
            },
            {
              label: '是否设置成分',
              type: 'select',
              prop: 'setComponent',
              data: [{label: '是', value: 1}, {label: '否', value: 0}],
              hidden: true,
              span: 8
            }
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addInfo,
            filter: (data) => {
              return !this.$utils.getSysUser().storeId || (this.$utils.getSysUser().storeClass && this.$utils.getSysUser().storeClass == 2)
            }
          },
          {
            label: '批量修改',
            code: 'batchModifying',
            callback: this.batchEdit
            // filter: (data) => {
            //   return false;
            // }
          },
          {
            label: '刷新',
            code: 'refresh',
            filter: (data) => {
              return false;
            }
          },
          {
            label: '批量新增',
            code: 'batchNew',
            callback: this.batchAddData,
            filter: (data) => {
              return false;
            }
          },
          {
            label: '下载导入模板',
            code: 'downloadTemplate',
            callback: this.downloadTemplate,
            filter: (data) => {
              return false;
            }
          },
          {
            label: '商品导入',
            code: 'goodsImport',
            callback: this.openImport
          },
          {
            label: '导出',
            code: 'goodsExport',
            callback: this.export,
            filter: (data) => {
              return false;
            }
          },
          {
            label: '设置',
            code: 'set',
            filter: (data) => {
              return false;
            }
          },
          {
            label: '商品同步',
            code: 'goodsSync',
            callback: this.goodsSync
          },
          {
            label: '一键同步',
            code: 'oenClickSync',
            callback: this.oenClickSync,
            filter: () => {
              return !this.$utils.getSysUser().storeId;
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.editInfo
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return false;
            }
          },
          {
            label: '设置一品多码',
            type: this.$utils.buttonType.tableOperate,
            callback: this.setBarCode,
            code: 'oneBarCodes',
            filter: (data) => {
              return true;
            }
          },
          {
            label: '设置小包装商品',
            type: this.$utils.buttonType.tableOperate,
            callback: this.setGoods,
            code: 'minGoods'
          },
          {
            label: '设置水果分级',
            type: this.$utils.buttonType.tableOperate,
            callback: this.setFruit,
            code: 'fruitLevel'
          },
          {
            label: '设置生鲜分割',
            type: this.$utils.buttonType.tableOperate,
            callback: this.setFresh,
            code: 'fresh'
          },
          {
            label: '规格设置',
            type: this.$utils.buttonType.tableOperate,
            callback: this.setSpecs,
            code: 'specsSetting',
            filter: (data) => {
              return !this.$utils.getSysUser().storeId
            }
          },
          {
            label: '批量删除',
            callback: this.batchDelete,
            code: 'batchDelete'
          },
          {
            label: '分店价格',
            callback: this.branchPrice,
            code: 'branchPrice',
            filter: (data) => {
              return !this.$utils.getSysUser().storeId;
            }
          },
          {
            label: '"批量修改商品分类"',
            code: 'batchUpdateCategory',
            filter: (data) => {
              return false;
            }
          }
        ],
        // 一品多码操作集合
        MultiCodeConfig: [
          {
            label: '删除',
            type: this.$utils.buttonType.tableOperate,
            code: 'delete',
            callback: this.deleteMultiCode
          }
        ],
        // 一品多码 column
        multiTableOptions: {
          indexShow: true,
          columns: [
            {label: '附加码', prop: 'code', width: 50, align: 'center'}
          ]
        },
        // 分店价格
        branchPriceTableData: [],
        branchPriceListColumns: {
          disabled: false,
          indexShow: true, // 是否显示索引
          columns: [
            {
              label: '门店',
              prop: 'storeName',
              width: '100'
            },
            {
              label: '成本价',
              prop: 'purchasePrice',
              width: '100'
            },
            {
              label: '进价',
              prop: 'buyPrice',
              width: '100'
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '100'
            },
            {
              label: '会员价',
              prop: 'vipPrice',
              width: '100'
            },
            {
              label: 'PLUS会员价',
              prop: 'plusVipPrice',
              width: '100'
            },
            {
              label: '库存',
              prop: 'inventoryNum',
              width: '100'
            }
          ]
        },
        // 表格信息配置
        tableOptions: {
          border: true,
          showSelect: true,
          // height: 710,
          indexShow: true,
          clearSortable: true, // 显示恢复默认排序
          columns: [
            {label: '条码', prop: 'barCode', width: '140', align: 'center', sortable: 'custom'},
            {label: '自编码', prop: 'artNo', width: '140', align: 'center', sortable: 'custom'},
            {label: '商品名称', prop: 'name', width: '160', align: 'center', sortable: 'custom'},
            {label: '单位', prop: 'unitName', width: '90', align: 'center'},
            {
              label: '规格',
              prop: 'buyPrice',
              width: '90',
              align: 'center',
              deal: this.specsDetail,
              callback: this.specsClick
            },
            {label: '进货价', prop: 'buyPrice', width: '100', align: 'center', sortable: 'custom'},
            {label: '零售价', prop: 'retailPrice', width: '100', align: 'center', sortable: 'custom'},
            {label: '毛利率', prop: 'profitRate', width: '100', align: 'center', deal: this.maoLv, sortable: 'custom'},
            {label: '会员价', prop: 'vipPrice', width: '100', align: 'center', sortable: 'custom'},
            {label: '批发价', prop: 'tradePrice', width: '100', align: 'center', sortable: 'custom'},
            {label: '最低售价', prop: 'lowestPrice', width: '120', align: 'center', sortable: 'custom'},
            {
              label: '状态',
              prop: 'status',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('asGoods.status')
            },
            {label: '商品类别', prop: 'goodsCategoryName', width: '120', align: 'center', sortable: 'custom'},
            {label: '品牌', prop: 'goodsBrandName', width: '120', align: 'center', sortable: 'custom'},
            {label: '供应商', prop: 'supplierName', width: '120', align: 'center', sortable: 'custom'},
            {
              label: '来源',
              prop: 'addType',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('asGoods.addType'),
              sortable: 'custom'
            },
            {label: '图片', prop: 'goodsImageUrl', width: '90', align: 'center', type: 'image'},
            {
              label: '创建时间',
              prop: 'createDttm',
              width: '190',
              align: 'center',
              sortable: 'custom'
            }
          ],
          url: api.archives.goodsInfo,
          param: {
            descColumn: null,
            ascColumn: null
          }
        },
        detailColumns: {
          span: 8,
          labelWidth: '130',
          columns: [
            {label: '品牌编码', prop: 'code'},
            {label: '品牌名称', prop: 'name'},
            {
              label: '状态',
              prop: 'status',
              enumData: this.$utils.getCacheStatus('asBrand.status')
            },
            {label: '创建时间', prop: 'createDttm'}
          ],
          url: api.archives.goodsInfo
        },
        goodsSearchOptions: {
          simple: [
            {
              label: '商品条码',
              type: 'input',
              prop: 'goodsCode',
              placeholder: '请输入商品条码'
            },
            {
              label: '商品名称',
              type: 'input',
              prop: 'name',
              placeholder: '请输入商品名称'
            },
            {
              label: '单位',
              type: 'select',
              prop: 'goodsUnitId',
              data: [],
              url: api.archives.goodsUnit
            },
            {
              label: '商品售价',
              type: 'input',
              prop: 'retailPrice',
              placeholder: '请输入商品售价'
            },
            {
              label: '规格数量',
              type: 'input',
              prop: 'sizeNumber',
              placeholder: '请输入规格数量'
            }

          ]
        },
        // 一品多码
        tableData: {
          showSelect: true,
          indexShow: true, // 是否显示索引
          columns: [
            {
              align: 'center',
              prop: 'barcode',
              label: '商品条码',
              width: '500px'
            }
          ],
          url: api.archives.goodsBarCode,
          param: {goodsId: ''}
        },
        currentBarCodePro: {},
        // 设置小包装商品
        minColumns: {
          columns: [
            {label: '序号', type: 'index', width: 80, prop: 'idx'},
            {label: '操作', type: 'operation', width: 130, prop: 'operation'},
            {
              label: '条码',
              prop: 'barCode',
              // type: 'more',
              // callback: this.getInfo,
              width: '130'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '成分数量',
              prop: 'specs',
              width: '90'
            }
          ]
        },
        // 设置水果分级
        fruitColumns: {
          columns: [
            {label: '序号', type: 'index', width: 80, prop: 'idx'},
            {label: '操作', type: 'operation', width: 130, prop: 'operation'},
            {
              label: '条码',
              prop: 'barCode',
              // type: 'more',
              // callback: this.getInfo,
              width: '130'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '成分数量',
              prop: 'specs',
              width: '90'
            }
          ]
        },
        // 设置生鲜分级
        freshColumns: {
          columns: [
            {label: '序号', type: 'index', width: 80, prop: 'idx'},
            {label: '操作', type: 'operation', width: 130, prop: 'operation'},
            {
              label: '条码',
              prop: 'barCode',
              // type: 'more',
              // callback: this.getInfo,
              width: '130'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '成分数量',
              prop: 'specs',
              width: '90'
            }
          ]
        },
        // 同步商品
        syncTableOptions: {
          indexShow: true, // 是否显示索引
          indexMethod: (index) => { // 自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '210',
              align: 'center'
            },
            {
              label: '品名',
              prop: 'goodsName',
              width: '100',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100',
              align: 'center',
              deal: this.specsDetail,
              callback: this.specsClickSync
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '80',
              align: 'center'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '150',
              align: 'center',
              type: 'inputNumber',
              precision: 2
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '150',
              align: 'center',
              type: 'inputNumber',
              precision: 2
            },
            {
              label: '库存',
              prop: 'inventoryNum',
              width: '150',
              align: 'center',
              type: 'inputNumber',
              precision: 2
            }
          ],
          url: api.archives.noGoodsSync
        },

        changePwdDialog: {
          formType: 'insert', // 添加
          labelWidth: '140px',
          span: 12,
          columns: [
            {label: '基础信息', type: 'title', span: 24},
            {
              label: '修改项',
              type: 'select',
              prop: 'orderMes',
              multiple: true,
              data: [
                {
                  label: '商品类别',
                  value: 'goodsCategoryId'
                },
                {
                  label: '品牌',
                  value: 'goodsBrandId'
                },
                {
                  label: '供应商',
                  value: 'supplierId'
                },
                {
                  label: '单位',
                  value: 'unitName'
                }
              ],
              change: this.goodsCategory
            },
            {
              label: '商品类别',
              type: 'select',
              prop: 'goodsCategoryId',
              placeholder: '请输入商品类别',
              data: [],
              url: api.archives.categoryList,
              isShow: false
            },
            {
              label: '品牌',
              type: 'select',
              prop: 'goodsBrandId',
              data: [],
              span: 12,
              url: api.archives.brand,
              isShow: false
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              width: '100',
              align: 'center',
              data: [],
              url: api.archives.supplier,
              isShow: false
            },
            {
              label: '单位',
              type: 'select',
              prop: 'unitName',
              data: [],
              url: api.archives.goodsUnit,
              isShow: false
            },
            {label: '状态信息', type: 'title', span: 24},
            {
              label: '商品状态',
              type: 'select',
              prop: 'status',
              data: this.$utils.getCacheStatus('asGoods.status')
            },
            {
              label: '计价方式',
              type: 'select',
              prop: 'pricingMethod',
              data: this.$utils.getCacheStatus('asGoods.pricingMethod')
            },
            {
              label: '商品类型',
              type: 'select',
              prop: 'type',
              data: this.$utils.getCacheStatus('asGoods.type')
            },
            {label: '优惠信息', type: 'title', span: 24},
            {
              label: '会员折扣生成',
              type: 'switch',
              defaultValue: false,
              prop: 'vipDiscount'
            },
            {
              label: '允许促销',
              type: 'switch',
              prop: 'promotion'
            },
            {
              label: '允许议价',
              type: 'switch',
              defaultValue: true,
              prop: 'bargaining'
            },
            {
              label: '线下折扣',
              type: 'switch',
              prop: 'offlineDiscount'
            },
            {
              label: '线上折扣',
              type: 'switch',
              prop: 'onlineDiscount'
            },
            {
              label: '允许赠送',
              type: 'switch',
              prop: 'give'
            },
            {
              label: '导购员提成',
              type: 'select',
              prop: 'guiderCommissionType',
              data: this.$utils.getCacheStatus('sysGuideMap.commissionType')
            },
            {
              label: '提成率',
              type: 'input',
              prop: 'commissionPercentage'
            },
            {
              label: '提成金额',
              type: 'input',
              prop: 'commissionMoney'
            },
            {label: '更多资料', type: 'title', span: 24},
            {
              label: '生鲜商品',
              type: 'switch',
              defaultValue: false,
              prop: 'isFreshGoods'
            },
            {
              label: '日清商品',
              type: 'switch',
              defaultValue: false,
              prop: 'nissiGoods'
            },
            {
              label: '鲜榨商品',
              type: 'switch',
              prop: 'squeezeGoods'
            },
            {
              label: '高值商品',
              type: 'switch',
              prop: 'highValueGoods'
            },
            {
              label: '交班盘点',
              type: 'switch',
              prop: 'takeStockGoods'
            },
            {
              label: '管理串号',
              type: 'switch',
              prop: 'manageSerialNumber'
            }
          ],
          formData: {}, // 表单数据
          options: {
            labelWidth: '180px'
          }
        },
        // 批量新增
        goodsAddColumns: {
          columns: [
            {label: '序号', type: 'index', width: 80, prop: 'idx'},
            {label: '操作', type: 'operation', width: 130, prop: 'operation'},
            {
              label: '条码',
              prop: 'barCode',
              // type: 'more',
              // callback: this.getInfo,
              width: '150',
              type: 'input'
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '150',
              type: 'input'
            },
            {
              label: '单位',
              prop: 'unitId',
              align: 'center',
              type: 'select',
              width: '120',
              data: [],
              url: api.archives.goodsUnit
            },
            {
              label: '供应商',
              type: 'select',
              prop: 'supplierId',
              width: '120',
              align: 'center',
              data: [],
              url: api.archives.supplier
            },
            {
              label: '商品类别',
              type: 'select',
              prop: 'goodsCategoryId',
              data: [],
              url: api.archives.categoryList,
              width: '120',
              align: 'center'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '120',
              align: 'center',
              type: 'inputNumber',
              precision: 2
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '120',
              align: 'center',
              type: 'inputNumber',
              precision: 2
            }

          ]
        },
        specsDialog: false,
        specsRow: {},
        addInfoShow: false,
        dialogTitle: '',
        addForm: {
          barCode: '', // 条码
          artNo: '', // 自编码
          name: '', // 名称
          goodsAbbreviate: '', // 简称
          mnemonicCode: '', // 助记码
          specs: '', // 规格
          goodsCategoryId: '', // 类别
          goodsBrandId: '', // 品牌
          goodsUnitId: '', // 单位
          goodsImageUrl: '', // 主图
          onlineImgMapList: [], // 详情图
          buyPrice: 0, // 进货价
          guidePrice: '', // 指导价
          retailPrice: '', // 零售价
          tradePrice: '', // 批发价
          deliveryPrice: '', // 配送价
          lowestPrice: '', // 最低售价
          inventoryNum: '', // 初始库存
          vipPrice: '', // 会员价
          openMall: false, // 商城销售
          onlineImgUrl: '', // 图片链接
          mallRetailPrice: '', // 商城零售价
          mallVipPrice: '', // 商城会员价
          mallPlusVipPrice: '', // 商城PLUS价
          mallLowestPrice: '', // 商城最低价
          supplierId: '', // 供应商
          manageType: 1, // 经营方式
          buySpecs: '1', // 进货规格
          purchaseCycle: '', // 采购周期
          jointOperationRate: '', // 联营扣率
          openSpecs: false, // 是否多规格
          openCombination: 0, // 商品类型 0普通商品 1组合商品 2自动转货
          father: false, // true的时候就是属于大商品，然后可以编辑子商品
          placeOrigin: '', // 产地
          goodsLevel: '', // 等级
          status: 10, // 商品状态
          pricingMethod: 10, // 计价方式
          openInventory: true, // 是否开启管理库存
          lowInventory: '', // 库存低位
          highInventory: 9999.999, // 库存高位
          promotion: '', // 允许促销
          bargaining: true, // 允许议价
          offlineDiscount: true, // 允许折扣
          give: true, // 允许赠送
          guiderCommissionType: 20, // 提成方式,默认按比例
          commissionPercentage: 0.00, // 提成率
          commissionMoney: 0, // 提成金额
          syncStore: true, // 是否同步至门店
          storeLists: [], // 门店
          sonVoList: [], // 组合子商品
          businessType: 10,
          combinationType: 20, // 20捆绑销售 30自动转货
          asGoodsSpecsMapList: [], // 多规格列表

          vipDiscount: false, // 会员折扣生成
          onlineDiscount: false, // 线上折扣
          deliveryType: '', // 配送模式
          joinDelivery: '', // 加盟配送
          openVipPrice: false, // 是否开启会员价
          openPlusPrice: false, // 是否Plus会员价
          plusVipPrice: null, // 输入Plus会员价
          isFreshGoods: false, // 生鲜商品
          nissiGoods: false, // 日清商品
          squeezeGoods: false, // 鲜榨商品
          highValueGoods: false, // 高值商品
          takeStockGoods: false, // 交班盘点
          manageSerialNumber: '', // 管理串号
          goodsProduceTime: '', // 生产日期
          qualityGuaranteePeriod: ''// 保质期
        },
        rules: {
          barCode: [{validator: validateCode, required: true, trigger: 'blur'}],
          artNo: [{validator: validateCode, trigger: 'blur'}],
          supplierId: [{required: true, message: '请选择供应商', trigger: 'change'}],
          name: [{required: true, message: '商品名称不能为空', trigger: 'blur'}],
          goodsCategoryId: [{required: true, message: '商品类别不能为空', trigger: 'change'}],
          goodsBrandId: [{required: true, message: '商品品牌不能为空', trigger: 'change'}],
          // goodsUnitId:[{required:true,message:'单位不能为空',trigger:'change'}],
          buyPrice: [
            {required: true, message: '商品进货价不能为空', trigger: 'blur'},
            {type: 'number', max: 99999.99}
          ],
          retailPrice: [{required: true, message: '商品零售价不能为空', trigger: 'blur'}],
          openSpecs: [{required: true, trigger: 'change'}],
          openCombination: [{required: true, trigger: 'change'}]
        },
        settingInfo: {},
        deductionRate: null,
        userInfo: {},
        isEdit: false,
        isEditCode: false, // 条码是否可编辑
        isEditPrice: false,
        scopeRow: {},
        specsForm: null,
        isChecked: false
      };
    },
    beforeDestroy() {
      clearInterval(this.interval);
      this.interval = null;
    },
    created() {
      this.getSupplier()
      this.getBrand()
      this.getUnit()
      this.getStoreList()
      this.userInfo = this.$utils.getSysUser()
      console.log(this.userInfo)
      this.getSettingStatus()
      pinyin.setOptions({checkPolyphone: false, charCase: 0});// 获取首字母
    },
    mounted() {
      this.getGoodsCategory()
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.code == '1') { // 智能分析跳转过来
          this.addInfo()
        }
      }
    },
    computed: {
      // 经营方式
      manageTypeList() {
        return this.$utils.getCacheStatus('asSupplier.type')
      },
      // 计价方式
      pricingMethodList() {
        return this.$utils.getCacheStatus('asGoods.pricingMethod')
      },
      // 商品状态
      statusList() {
        return this.$utils.getCacheStatus('asGoods.status')
      },
      // 导购员提成方式
      guiderTypeList() {
        return this.$utils.getCacheStatus('asGoods.guiderCommissionType')
      }
    },
    watch: {
      // 一品多码添加条形码监听事件
      productCode(newval, oldval) {
        if (this.productCode != '') {
          this.btnbool1 = false
        } else {
          this.btnbool1 = true
        }
      },
      // 小包装商品增加按钮监听事件
      packageGoodsCode(newval, oldval) {
        if (this.packageGoodsCode != '' && this.packageGoodsCount != '') {
          this.btnbool2 = false
        } else {
          this.btnbool2 = true
        }
      },
      packageGoodsCount(newval, oldval) {
        if (this.packageGoodsCode != '' && this.packageGoodsCount != '') {
          this.btnbool2 = false
        } else {
          this.btnbool2 = true
        }
      },
      // 水果分级按钮监听事件
      fruitCode(newval, oldval) {
        if (this.fruitCode != '' && this.fruitCount != '') {
          this.btnbool3 = false
        } else {
          this.btnbool3 = true
        }
      },
      fruitCount(newval, oldval) {
        if (this.fruitCode != '' && this.fruitCount != '') {
          this.btnbool3 = false
        } else {
          this.btnbool3 = true
        }
      },
      // 生鲜分割按钮监听事件
      freshCode(newval, oldval) {
        if (this.freshCode != '' && this.freshCount != '') {
          this.btnbool4 = false
        } else {
          this.btnbool4 = true
        }
      },
      freshCount(newval, oldval) {
        if (this.freshCode != '' && this.freshCount != '') {
          this.btnbool4 = false
        } else {
          this.btnbool4 = true
        }
      }

    },
    methods: {
      getUpdateResult({
                        operationRecordId = this.updateOperationRecordId,
                        pageNumber = this.errUpdatePageNo,
                        pageSize = 10
                      }) {
        const param =
          {
            pageNumber,
            pageSize,
            operationRecordId
          }
        this.$axios.fetchPost(api.archives.getErrorReason, param).then(res => {
          this.errorUpdateData = res.data.records
          this.errorUpdateCount = res.data.total;
          if (this.errorUpdateCount && this.errorUpdateCount > 0) {
            this.isShowSyncUpdateDetail = true;
          } else {
            this.isShowSyncUpdateDetail = false;
          }
        })
      },
      getResult({operationRecordId = this.operationRecordId, pageNumber = this.errPageNo, pageSize = 10}) {
        const param =
          {
            pageNumber,
            pageSize,
            operationRecordId
          }
        this.$axios.fetchPost(api.archives.getErrorReason, param).then(res => {
          this.errorData = res.data.records
          this.errorCount = res.data.total;
          if (this.errorCount && this.errorCount > 0) {
            this.isShowSyncInsertDetail = true;
          } else {
            this.isShowSyncInsertDetail = false;
          }
        })
      },
      changeBarCodePage(val) {
        console.log(val)
        this.currentBarCodePageNo = val
        this.setBarCode({barCode: this.currentBarCodePro.barCode})
      },
      initData() {
        this.storeId = null;
        this.shopList = []
      },
      syncColumnList({all = false}) {
        if (this.storeId == null || this.storeId === '') return this.$message.warning('请选择门店')
        console.log(this.goodsList)
        if (this.goodsList.length === 0) return this.$message.warning('请选择字段')
        this.confirm = true
        this.updateStep = 1
        const selectRow = this.$refs.goodsInfo.getTableSelectRow()
        const goodsList = selectRow.map(item => {
          return {barCode: item.barCode}
        })
        const param = {
          merchantId: this.userInfo.merchantId,
          storeId: this.storeId,
          all,
          goodsColumnList: this.goodsList,
          goodsMVOList: goodsList
        }
        this.$axios.fetchPost(api.archives.updateSyncList, param).then(data => {
          console.log(data)
          this.updateStep = 2
          // if (res.code === 200) {
          //   this.$message.success('操作成功！')
          //   this.initData();
          //   this.listShow = false
          //   this.goodsList = []
          // } else {
          //   this.$message.error(('网络异常'))
          // }
          this.goodsList = []
          this.confirm = false
          if (data.code === 200) {
            this.updateOperationRecordId = data.data
            if (data.data) {
              this.getUpdateResult({operationRecordId: data.data})
            }
            this.importUpdateStatus = true
            return this.$notify({
              type: "success",
              title: '同步操作',
              message: '成功',
              showClose: false,
            });
            // return this.$message({message: '同步完成', type: 'success'})
          } else {
            if (data.errorMsg) {
              return this.$message({message: data.errorMsg, type: 'warning'});
            } else {
              return this.$message({message: '同步异常', type: 'error'});
            }
          }
        })
      },
      // 同步商品
      syncShop({all = false}) {
        if (this.storeId == null || this.storeId === '') return
        const selectRow = this.$refs.goodsInfo.getTableSelectRow()
        const goodsList = selectRow.map(item => {
          return {barCode: item.barCode}
        })
        this.syncStep = 1;
        this.importStatus = false
        const param = {
          merchantId: this.userInfo.merchantId,
          storeId: this.storeId,
          all: all,
          goodsMVOList: goodsList
        }
        this.$axios.fetchPost(api.archives.syncGoodsToShop, param).then(data => {
          console.log(data)
          this.syncStep = 2
          this.operationRecordId = data.data

          if (data.code === 200) {
            if (data.data) {
              this.getResult({operationRecordId: data.data});
            }
            this.importStatus = true
            return this.$notify({
              type: "success",
              title: '同步操作',
              message: '成功',
              showClose: false,
            });
            // return this.$message({message: '同步完成', type: 'success'})
          } else {
            if (data.errorMsg) {
              return this.$message({message: data.errorMsg, type: 'warning'});
            } else {
              return this.$message({message: '同步异常', type: 'error'});
            }
          }
          // if (res.code === 200) {
          //   this.$message.success('操作成功!');
          //   this.listShow = false
          //   this.storeId = null;
          // } else {
          //   this.$message.error('请求出错');
          // }
        }).finally(() => {
          this.storeId = null;
        })
      },
      // 同步商品展示弹窗
      goodsSync() {
        const selectRow = this.$refs.goodsInfo.getTableSelectRow()
        if (selectRow.length === 0) return this.$message.warning('请先选择商品')
        this.listShow = true;
        this.selectProduct = selectRow.length
        this.getShopList()
        this.getSyncColumnList()

        // this.$nextTick(() => {
        //   this.$refs['goodsSync'].getTableData();
        // })
      },
      // 获取门店列表
      getShopList() {
        this.$axios.fetchPost(api.archives.shopColumn).then(res => {
          if (res.code === 200) {
            this.shopList = res.data
          } else {
            this.$message.error('网络异常！')
          }
        })
      },
      // 获取同步列名
      getSyncColumnList() {
        this.$axios.fetchPost(api.archives.syncColumnList).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.labelList = res.data
          }
        })
      },
      handleCheckedChange(val) {
        console.log(val)
        console.log(this.goodsList)
      },
      // 删除一品多码
      deleteMultiCode(val) {
        const {id} = val
        this.$axios.fetchDelete(api.archives.goodsBarCode, {id: id}).then(res => {
          this.setBarCode({barCode: this.currentBarCodePro.barCode})
          // this.$message.success('删除成功');
          this.$notify({
            type: "success",
            title: '删除操作',
            message: '成功',
            showClose: false,
          });
        })
      },
      // 切换提成方式
      changeGuider(val) {
        if (this.isChecked) {
          if (val === 20) {
            this.batchList.push('commissionPercentage')
            this.batchRules['commissionPercentage'][0].required = true
          }
          if (val === 30) {
            this.batchList.push('commissionMoney')
            this.batchRules['commissionMoney'][0].required = true
          }
        } else {
          this.batchList.filter(v => v.prop != 'commissionPercentage' || v.prop != 'commissionMoney')
          this.batchRules['commissionPercentage'][0].required = false
          this.batchRules['commissionMoney'][0].required = false
        }
      },
      changePrevent() {
        console.log(this.batchList)
      },
      // 点击当前复选框
      changeBatchItem(isCheck, prop) {
        this.$refs['batchForm'].clearValidate()// 只清空表单验证
        if (isCheck) {
          if (prop === 'guiderCommissionType') {
            this.isChecked = true
            this.changeGuider(this.batchForm.guiderCommissionType)
          } else {
            this.isChecked = false
            this.batchRules[prop][0].required = true
          }
        } else {
          if (prop === 'guiderCommissionType') {
            this.isChecked = false
            this.changeGuider()
          } else {
            this.batchRules[prop][0].required = false
          }
        }
      },
      // 提交批量修改
      saveBatch() {
        if (this.batchList.length === 0) {
          this.$message.warning('请勾选需要提交的数据')
        } else {
          let paramForm = {}
          this.batchList.forEach(v => {
            paramForm[v] = this.batchForm[v]
          })
          this.$refs.batchForm.validate(valid => {
            if (valid) {
              let arr = []
              let list = this.$refs.goodsInfo.getTableSelectRow()
              list.forEach(v => {
                arr.push(v.id)
              })
              let params = {ids: arr, ...paramForm}
              this.$axios.fetchPost(api.archives.batchUpdate, params).then(res => {
                if (res.code === 200) {
                  if (res.data) {
                    this.$notify({
                      type: "success",
                      title: '批量修改操作',
                      message: '成功',
                      showClose: false,
                    });
                    // this.$message.success('批量修改成功')
                    this.$refs['goodsInfo'].getData()
                    this.closeBatch()
                  }
                } else {
                  this.$message.error(res.code + res.errorMsg)
                }
              })
            } else {
              return false
            }
          })
        }
      },
      // 选择批量修改
      changeBatch(val) {
      },
      // 批量修改
      batchEdit() {
        let goodsList = this.$refs.goodsInfo.getTableSelectRow();
        if (goodsList.length === 0) {
          this.$message({message: '请勾选数据后进行批量修改！', type: 'warning'});
        } else {
          // this.addColumns && this.$store.commit('OTHERFORM', this.changePwdDialog);
          // this.$refs['addForm'].setFormOptions('other', '1', '批量修改');
          this.batchShow = true
        }
      },
      // 关闭批量修改
      closeBatch() {
        this.batchShow = false
        this.batchList = []
        this.batchRules = {
          goodsCategoryId: [{required: false, message: '商品类别不能为空', trigger: 'change'}],
          goodsBrandId: [{required: false, message: '商品品牌不能为空', trigger: 'change'}],
          goodsUnitId: [{required: false, message: '单位不能为空', trigger: 'change'}],
          commissionPercentage: [{required: false, message: '提成率不能为空', trigger: 'blur'}],
          commissionMoney: [{required: false, message: '提成金额不能为空', trigger: 'blur'}],
          placeOrigin: [{required: false, message: '产地不能为空', trigger: 'blur'}],
          goodsLevel: [{required: false, message: '等级不能为空', trigger: 'blur'}],
          purchaseCycle: [{required: false, message: '采购周期不能为空', trigger: 'blur'}],
          qualityGuaranteePeriod: [{required: false, message: '保质期不能为空', trigger: 'blur'}],
          lowInventory: [{required: false, message: '库存低位不能为空', trigger: 'blur'}],
          highInventory: [{required: false, message: '库存高位不能为空', trigger: 'blur'}]
        }
        this.$refs.batchForm.resetFields()
      },
      // 搜索选择商品类型
      combinationChange(form) {
        form.setComponent = '';
        let setComponent = this.searchOptions.complex.filter(v => v.prop === 'setComponent')[0];
        if (form.openCombination) {
          setComponent.hidden = false;
          if (form.openCombination === 1) {
            form.father = true
          } else {
            form.father = false
          }
        } else {
          setComponent.hidden = true;
          form.father = '';
        }
      },
      // 查看多规格详情
      specsDetail(row, column) {
        if (row.openSpecs) {
          return '<span class="td-click">多规格</span>'
        } else {
          if (row.specs) {
            return '<span>' + row.specs + '</span>'
          }
        }
      },
      // 同步商品点击多规格查看
      specsClickSync(row) {
        if (row.asGoodsSpecsMapList && row.asGoodsSpecsMapList.length > 0) {
          this.specsDetailData = []
          this.specsDetailShow = true
          this.$nextTick(() => {
            this.specsDetailData = row.asGoodsSpecsMapList
          });
        }
      },
      // 点击多规格查看
      specsClick(row) {
        if (row.openSpecs) {
          this.specsDetailData = []
          this.specsDetailShow = true
          this.$loading({})
          this.$axios.fetchPost(api.baseInfo.getSpecsList, {goodsId: row.id}).then((data) => {
            if (data.code == 200) {
              if (data.data && data.data.specsList) {
                this.$nextTick(() => {
                  this.specsDetailData = data.data.specsList
                })
              }
            }
          }).finally(() => {
            this.$loading({}).close()
          })
        }
      },
      // 编辑时获取组合商品列表
      getSonList(id) {
        this.$axios.fetchPost(api.archives.combinationSonList, {goodsId: id}).then(res => {
          if (res.code === 200) {
            if (res.data && res.data.length > 0) {
              this.$refs['listOperation'].addMoreRow(res.data, 0);
            }
          } else {
            this.$message.error(res.errorMsg || '请求失败')
          }
        })
      },
      // 组合商品 选择商品
      showSonGoodsList(row, index) {
        this.listTableData = this.$refs['listOperation'].getTabelData()// table数据
        this.goodsListShow = true;
        this.$nextTick(() => {
          this.$refs.goodsListOperation.getTableData();
        });
      },
      // 输入条码 获取商品信息
      queryGoodsByBarCode(param, index) {
        this.otherParam.barCode = param.barCode;
        // this.otherParam.openCombination = 0;
        this.$axios.fetchPost('/api/eros/as/asGoods/specs', this.otherParam).then(data => {
          if (data.code === 200) {
            if (data.data) {
              // 判断是否重复
              if (this.$refs['listOperation'].getTabelData().length > 0) {
                let arr = this.$refs['listOperation'].getTabelData()
                let result = arr.some(v => {
                  return v.goodsId === data.data.goodsId
                })
                if (result) { // 如果已经存在
                  this.$message({message: '该商品已被选择！', type: 'warning'});
                  this.$refs['listOperation'].setColumnData([], index);
                } else {
                  this.$refs['listOperation'].setColumnData(data.data, index);
                }
              } else {
                this.$refs['listOperation'].setColumnData(data.data, index);
              }
            } else {
              this.$message({message: '无对应商品！', type: 'warning'});
              this.$refs['listOperation'].setColumnData([], index);
            }
          } else {
            this.$message({message: '请求失败！', type: 'error'});
          }
        }).catch(() => {
        });
        this.otherParam.barCode = null;
      },
      // 组合商品 输入数量
      numChange(row, index) {
        row.totalPrice = parseFloat(row.buyPrice * row.goodsNum).toFixed(2);
        this.$refs.listOperation.setCountData(row, index);
      },
      getTotalPrice(row, index) {
        row.totalPrice = parseFloat(row.buyPrice * row.goodsNum).toFixed(2);
      },
      // 点击设置子商品
      setSonGoods() {
        this.sonListShow = true;
        if (!this.addForm.sonVoList) {
          this.addForm.sonVoList = []
        }
        if (this.addForm.openCombination === 1) {
          this.sonListColumns.hideSum = false
        }
        if (this.addForm.openCombination === 2) {
          this.sonListColumns.hideSum = true
        }
        this.$nextTick(() => {
          if (this.addForm.sonVoList.length > 0) {
            this.$refs['listOperation'].addMoreRow(this.addForm.sonVoList, 0)
          }
          if (this.dialogTitle === '编辑') {
            if (this.addForm.sonVoList.length === 0) {
              this.getSonList(this.scopeRow.id)
            }
          }
        })
      },
      // 选择商品 多行
      rowsSelectSubmit(rows) {
        this.goodsListShow = false;
        let tableList = this.$refs['listOperation'].getTabelData();
        this.$refs['listOperation'].addMoreRow(rows, tableList.length);
      },
      // 保存组合商品
      saveSonList() {
        let list = this.$refs['listOperation'] && this.$refs['listOperation'].getTabelData()
        let result = false
        if (list.length > 0) {
          result = list.some(v => {
            return v.goodsNum == 0
          })
        }
        if (result) {
          this.$message.warning('成分数量不能为0')
        } else {
          this.sonListShow = false;
          this.addForm.sonVoList = this.$refs['listOperation'] && this.$refs['listOperation'].getTabelData();
        }
      },
      // 切换规格
      changeOpenSpecs(val) {
        if (val) {
          this.addForm.openCombination = 0
          this.addForm.father = false
        }
        this.specsForm = null
      },
      // 点击保存多规格管理
      submitSuccess(tableData, ruleList, sublist) {
        this.specsDialog = false
        this.addForm.asGoodsSpecsMapList = tableData
        this.specsForm = {tableData, ruleList, sublist}
        console.log(this.specsForm)
      },
      requestSubmit(tableData, ruleList, sublist) {
        this.addForm.asGoodsSpecsMapList = tableData
        this.specsForm = {tableData, ruleList, sublist}
      },
      // 点击 新增多规格
      addSetSpecs() {
        if (!this.addForm.barCode) {
          this.$message.warning('商品条码不能为空')
        } else if (!this.addForm.retailPrice || !this.addForm.buyPrice) {
          this.$message.warning('进货价、零售价不能为空')
        } else {
          this.specsRow = this.addForm;
          if (this.dialogTitle === '新增') {
            this.specsDialog = true;
            this.specsRow.formType = 'add'
          }
          if (this.dialogTitle === '编辑') {
            if (this.addForm.pricingMethod === 30) {
              this.$message.warning('当前商品不允许设置规格')
            } else {
              this.specsDialog = true;
              this.specsRow.formType = 'edit'
              this.num = this.num + 1
              this.specsRow.num = this.num
            }
          }
        }
      },
      // 选择商品类型
      changeCombination(val) {
        this.otherParam.openSpecs = false;
        if (val === 1) {
          this.otherParam.sonGoodsType = 1;
        } else if (val === 2) {
          this.otherParam.sonGoodsType = 2;
        } else {
          this.otherParam.sonGoodsType = null;
        }
        this.addForm.sonVoList = []
        if (this.$refs.listOperation) {
          this.$refs.listOperation.clearTableData()
        }
      },
      // 毛利率
      maoLv(row) {
        let value
        if (row.profitRate) {
          if (row.profitRate.indexOf('%') != -1) {
            value = row.profitRate.split('%')[0]
          } else {
            value = row.profitRate
          }
        }
        return `<span>${(Number(value) * 100).toFixed(2)}%</span>`;
      },
      // 是否同步至门店
      isSyncStore(val) {
        if (val) {
          this.storeChecked = true
          this.selectAll()
        } else {
          this.addForm.storeLists = []
        }
      },
      // 门店全选
      selectAll() {
        this.addForm.storeLists = []
        if (this.storeChecked) {
          this.storeList.map((item) => {
            this.addForm.storeLists.push(item.id)
          })
        } else {
          this.addForm.storeLists = []
        }
      },
      // 选择门店
      changeStore(val) {
        if (val.length === this.storeList.length) {
          this.storeChecked = true
        } else {
          this.storeChecked = false
        }
      },
      // 多选模式下移除tag时触发
      removeTag(val) {
        if (this.isEdit) {
          this.addForm.storeLists = this.oldData.storeLists
        }
      },
      // 输入进货价
      changeBuyPrice(val) {
        if (this.dialogTitle !== '新增') return
        this.addForm.deliveryPrice = val
        if (this.addForm.lowestPrice) {
          if (this.addForm.lowestPrice - val < 0) {
            this.$confirm('最低零售价小于进货价，确认?', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              this.changeMallLower(this.addForm.mallLowestPrice);
            }).catch(() => {
              this.addForm.lowestPrice = val;
              if (this.addForm.retailPrice) {
                if ((this.addForm.retailPrice - this.addForm.lowestPrice) < 0) {
                  this.addForm.retailPrice = this.addForm.lowestPrice;
                }
              }
              this.changeMallLower(this.addForm.mallLowestPrice);
            })
          } else if (this.addForm.mallLowestPrice && (this.addForm.mallLowestPrice - val < 0)) {
            this.changeMallLower(this.addForm.mallLowestPrice);
          }
        }
      },
      // 输入零售价
      changeRetailPrice(val) {
        if (this.dialogTitle !== '新增') return
        this.addForm.mallRetailPrice = val
        this.addForm.mallVipPrice = val
        this.addForm.mallPlusVipPrice = val
        this.addForm.vipPrice = val
        this.addForm.tradePrice = val
        this.addForm.deliveryPrice = val
        if (this.addForm.lowestPrice && (val - this.addForm.lowestPrice) < 0) {
          this.$confirm('当前零售价低于最低售价', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.changeVipPrice(this.addForm.vipPrice);
          }).catch(() => {
            this.addForm.retailPrice = this.addForm.lowestPrice
          })
        }
      },
      // 输入会员价
      changeVipPrice(val) {
        if (this.addForm.retailPrice - val < 0) {
          this.$message.warning('会员价不能大于零售价')
          this.addForm.vipPrice = this.addForm.retailPrice;
        }
      },
      // 输入最低售价
      changeLowerPrice(val) {
        if (this.addForm.buyPrice) {
          if (val - this.addForm.buyPrice < 0) {
            this.$confirm('当前最低零售价低于进货价,是否继续操作?', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              this.lowestRetailPrice()
            }).catch(() => {
              this.addForm.lowestPrice = this.addForm.buyPrice;
              this.lowestRetailPrice()
            })
          } else {
            this.lowestRetailPrice()
          }
        }
      },
      lowestRetailPrice() {
        if (this.addForm.lowestPrice !== undefined && this.addForm.retailPrice !== undefined) {
          if ((this.addForm.retailPrice - this.addForm.lowestPrice) < 0) {
            this.$confirm('当前零售价低于最低售价', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              this.addForm.retailPrice = this.addForm.lowestPrice;
            }).catch(() => {
              this.addForm.retailPrice = this.addForm.lowestPrice;
            })
          }
        }
      },
      // 输入商城最低价
      changeMallLower(val) {
        if (this.addForm.buyPrice && this.addForm.mallLowestPrice) {
          if (val - this.addForm.buyPrice < 0) {
            this.$confirm('商城最低零售价小于进货价是否确认?', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              this.changeMallRetail(this.addForm.mallRetailPrice);
            }).catch(() => {
              this.addForm.mallLowestPrice = this.addForm.buyPrice;
              this.changeMallRetail(this.addForm.mallRetailPrice);
            })
          } else {
            this.changeMallRetail(this.addForm.mallRetailPrice);
          }
        }
      },
      // 输入商城零售价
      changeMallRetail(val) {
        if (this.addForm.mallLowestPrice) {
          if (val - this.addForm.mallLowestPrice < 0) {
            this.$confirm('商城零售价不能小于商城最低零售价!', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              this.addForm.mallRetailPrice = this.addForm.mallLowestPrice;
              this.changeMallVip(this.addForm.mallVipPrice);
            }).catch(() => {
              this.addForm.mallRetailPrice = this.addForm.mallLowestPrice;
              this.changeMallVip(this.addForm.mallVipPrice);
            })
          }
        }
      },
      // 输入商城会员价
      changeMallVip(val) {
        if (this.addForm.mallRetailPrice - val < 0) {
          this.$confirm('商城会员价不能大于商城零售价', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.addForm.mallVipPrice = this.addForm.mallRetailPrice;
            this.addForm.mallPlusVipPrice = this.addForm.mallRetailPrice;
          }).catch(() => {
            this.addForm.mallVipPrice = this.addForm.mallRetailPrice;
            this.addForm.mallPlusVipPrice = this.addForm.mallRetailPrice;
          })
        }
      },

      // 选择供应商
      changeSupplier(val) {
        this.addForm.jointOperationRate = ''
        this.$axios.fetchGet(api.archives.supplier + '?id=' + val, {}).then(res => {
          if (res.code == 200) {
            this.deductionRate = res.data.deductionRate// 供应商联营扣率
            this.addForm.jointOperationRate = res.data.deductionRate ? res.data.deductionRate : ''
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 获取门店
      getStoreList() {
        this.$axios.fetchPost(api.store.store + '/list', {syncMerchantGoods: true}).then(res => {
          if (res.code == 200) {
            this.storeList = res.data
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 获取商品类别
      getGoodsCategory() {
        this.$axios.fetchPost(api.archives.categoryList + '/tree/list', {}).then(res => {
          if (res.code == 200) {
            this.goodsCategoryList = res.data
            // let goodsCategoryIds = this.searchOptions.complex.filter(v=>v.prop === 'goodsCategoryIds')[0]
            // goodsCategoryIds.data = res.data
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 获取供应商
      getSupplier() {
        this.$axios.fetchPost(api.archives.supplier + '/list', {}).then(res => {
          if (res.code == 200) {
            this.supplierList = res.data
            let supplierId = this.searchOptions.complex.filter(v => v.prop === 'supplierId')[0]
            supplierId.data = res.data
            res.data.forEach(v => {
              // 默认其它供应商
              if (v.code === 'JARVIS_SYSTEM') {
                this.addForm.supplierId = v.id
              } else {
                this.addForm.supplierId = ''
              }
            })
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 获取品牌
      getBrand() {
        this.$axios.fetchPost(api.archives.brand + '/list', {}).then(res => {
          if (res.code == 200) {
            this.brandList = res.data
            let goodsBrandId = this.searchOptions.complex.filter(v => v.prop === 'goodsBrandId')[0]
            goodsBrandId.data = res.data
            res.data.forEach(v => {
              // 默认其它品牌
              if (v.code === 'JARVIS_SYSTEM') {
                this.addForm.goodsBrandId = v.id
              } else {
                this.addForm.goodsBrandId = ''
              }
            })
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 获取单位
      getUnit() {
        this.$axios.fetchPost(api.archives.goodsUnit + '/list', {}).then(res => {
          if (res.code == 200) {
            this.unitList = res.data
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 自动生成编码
      getCode() {
        this.$axios.fetchGet(api.archives.getAtrNo, {}).then(res => {
          if (res.code == 200) {
            this.addForm.barCode = res.data
            this.changeCode(this.addForm.barCode)
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        })
          .catch(err => {
            this.$message({type: 'error', message: '获取失败!'});
          })
      },
      // 云商品
      getCloudGood(code) {
        this.$axios.fetchPost('/api/eros/as/asGoodsCloud/query' + '?barCode=' + code, {}).then(res => {
          if (res.code === 200 && res.data) {
            if (res.data.name) {
              this.checkName(res.data.name)
              this.addForm.name = res.data.name
              this.addForm.specs = res.data.specs
              this.addForm.retailPrice = res.data.retailPrice
              this.changeRetailPrice(this.addForm.retailPrice)
              this.addForm.qualityGuaranteePeriod = res.data.qualityGuaranteePeriod// 保质期
              this.addForm.status = res.data.status
            }
            res.data.goodsImageUrl = res.data.imageLink1
            this.$refs.goodsImageUrl.dealFileData(res.data)
          }
        }).catch(() => {
        })
      },
      // 校验条码 自编码是否重复
      checkCodeRepeat(val) {
        if (val === 'barCode') { // 条码
          // const reg = /[A-Z0-9a-z_-]+$/;
          const reg = /^[a-zA-Z0-9-_]+$/;
          if (!reg.test(this.addForm.barCode.trim())) {
            this.$message({type: 'warning', message: '条码只能是数字、字母、中划线(-)、下划线(_)'});
            // this.$message.warning('条码只能是数字、字母、中划线(-)、下划线(_)');
            this.addForm.barCode = '';
            this.addForm.artNo = '';
            return;
          }
          this.$axios.fetchGet(api.archives.verifyBarcode + '?' + val + '=' + this.addForm.barCode.trim(), {}).then(result => {
            if (result.data == false) {
              this.$message({type: 'warning', message: '条码重复请重新输入'});
              this.addForm.barCode = ''
            } else if (result.code != 200) {
              this.$message({type: 'error', message: '验证失败'});
              this.addForm.barCode = ''
            } else {
              // 验证通过 不重复
              this.changeCode(this.addForm.barCode)
              this.getCloudGood(this.addForm.barCode.trim())
            }
          }).catch(err => {
            this.$message({type: 'error', message: '获取失败!'});
          })
        } else { // 自编码
          this.$axios.fetchGet(api.archives.verifyAtrNo + '?' + val + '=' + this.addForm.artNo.trim(), {}).then(result => {
            if (result.data == false) {
              this.$message({type: 'warning', message: '编码重复请重新输入'});
              this.addForm.artNo = ''
            } else if (result.code != 200) {
              this.$message({type: 'error', message: '验证失败'});
              this.addForm.artNo = ''
            } else {
              this.changeCode(this.addForm.artNo)
            }
          }).catch(err => {
            this.$message({type: 'error', message: '获取失败!'});
          })
        }
      },
      // 自编码自动截取条码后6位
      changeCode(code) {
        if (this.isSubstring) {
          if (code.length > 6) {
            this.addForm.artNo = code.substring((code.length - this.substringLength), code.length)
          } else {
            this.addForm.artNo = code
          }
        }
        // 条码改变，如果设置子规格，则子规格条码也变化
        if (this.addForm.openSpecs && this.addForm.asGoodsSpecsMapList.length > 0) {
          this.addForm.asGoodsSpecsMapList.map((v, i) => {
            const index = i + 1
            const flag = '-' + (index < 10 ? '0' + index : index)
            v.specsBarCode = code + flag
            v.specsArtNo = v.specsArtNo + flag
          })
        }
      },
      // 获取设置状态
      getSettingStatus(val) {
        this.$axios.fetchGet(api.archives.asGoodsDefaultInfo, {}).then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.settingInfo = res.data
            }
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
        })
      },
      // 验证名称重复
      checkFun(name) {
        return new Promise((resolve, reject) => {
          this.$axios.fetchPost(api.archives.goodsNameRepeat, {name: name}).then(res => {
            this.loading = false;
            if (res.code == 200) {
              if (!res.data) {
                this.$message({type: 'warning', message: '名称重复'});
                this.isReaptName = false
              } else {
                this.isReaptName = true
              }
              resolve(this.isReaptName)
            } else {
              reject()
              this.$message({type: 'error', message: res.msg});
            }
          })
            .catch(err => {
            })
        })
      },
      // 新增 校验名称重复
      checkName(val) {
        this.checkFun(this.addForm.name).then(() => {
          if (!this.isReaptName) {
            if (this.dialogTitle === '新增') {
              this.addForm.name = ''
            }
            if (this.dialogTitle === '编辑') {
              this.addForm.name = this.oldData.name
            }
          } else {
            // 简称取前10
            if (this.addForm.name.length > 10) {
              this.addForm.goodsAbbreviate = this.addForm.name.substring(0, 10)
            } else {
              this.addForm.goodsAbbreviate = this.addForm.name
            }
            // 助记码
            this.addForm.mnemonicCode = pinyin.getCamelChars(val).toUpperCase().substring(0, 10)
          }
        })
      },
      // 编辑 校验名称重复
      checkNameEdit(val) {
        if (this.editData.name && this.editData.name != val.name) {
          this.checkFun(val.name).then(() => {
            if (!this.isReaptName) {
              val.name = this.editData.name
            }
          })
        }
      },
      // 提交保存
      save() {
        this.$refs.addForm.validate(valid => {
          if (valid) {
            if (this.addForm.openCombination === 1 && this.addForm.sonVoList && this.addForm.sonVoList.length === 0) {
              this.$message.warning('组合商品信息不能为空，请设置子商品')
            } else if (this.addForm.openCombination === 2 && this.addForm.sonVoList && this.addForm.sonVoList.length === 0) {
              this.$message.warning('自动转货信息不能为空，请设置成分商品')
            } else if (this.addForm.openSpecs && this.addForm.asGoodsSpecsMapList && this.addForm.asGoodsSpecsMapList.length === 0) {
              this.$message.warning('多规格商品信息不能为空，请设置子规格')
            } else {
              if (!this.addForm.openSpecs) {
                this.addForm.asGoodsSpecsMapList = []
              }
              let fileList = this.$refs.goodsImageUrl.getFormData()
              let fileList1 = this.$refs.onlineImgMapList.getFormData()
              this.addForm.onlineImgMapList = []
              fileList1.forEach(v => {
                this.addForm.onlineImgMapList.push({imageUrl: v.response})
              })
              this.addForm.goodsImageUrl = fileList.length > 0 ? fileList[0].response : '';

              if (this.addForm.openCombination === 1) { // 组合商品
                this.addForm.combinationType = 20
                this.addForm.businessType = 20
                this.addForm.father = true
              } else if (this.addForm.openCombination === 2) { // 自动转货
                this.addForm.businessType = 30
                this.addForm.combinationType = 30
                this.addForm.father = true
              } else { // 普通商品
                this.addForm.combinationType = null
                this.addForm.businessType = 10
                this.addForm.father = false
                this.addForm.sonVoList = []
              }
              this.disabled = true
              const loading = this.$loading({
                lock: true,
                text: '加载中，请稍候...',
                background: 'rgba(255, 255, 255, 0.8)'
              });
              if (this.dialogTitle === '新增') {
                if (this.$utils.getSysUser().storeId) {
                  this.addForm.syncStore = false
                  this.addForm.storeLists = null
                }
                console.log(this.addForm)
                this.$axios.fetchPost(api.archives.goodsInfo, this.addForm).then(res => {
                  if (res.code === 200) {
                    this.$message({type: 'success', message: '保存成功'});
                    this.$refs['goodsInfo'].getData()
                    this.closeDialogAdd()
                  } else {
                    this.$message({type: 'error', message: res.msg});
                  }
                }).finally(() => {
                  loading.close()
                  this.disabled = false
                })
              }
              if (this.dialogTitle === '编辑') {
                // this.addForm.combinationType = 20
                this.addForm.openCombination = this.oldData.openCombination
                if (this.addForm.openCombination === 1) { // 组合商品
                  this.addForm.combinationType = 20
                  this.addForm.businessType = 20
                } else if (this.addForm.openCombination === 2) { // 自动转货
                  this.addForm.businessType = 30
                  this.addForm.combinationType = 30
                } else { // 普通商品
                  this.addForm.combinationType = null
                  this.addForm.businessType = 10
                }
                console.log(this.addForm)
                this.$axios.fetchPut(api.archives.goodsInfo, this.addForm).then(res => {
                  if (res.code === 200) {
                    this.$message({type: 'success', message: '保存成功'});
                    this.$refs['goodsInfo'].getData()
                    this.closeDialogAdd()
                  } else {
                    this.$message({type: 'error', message: res.msg});
                  }
                }).catch(err => {
                }).finally(() => {
                  loading.close()
                  this.disabled = false
                })
              }
            }
          } else {
            if (this.currentStep !== 0) {
              this.$message({type: 'warning', message: '请检查必填信息'});
            }
            return false
          }
        })
      },
      // 点击商城信息
      shopInfo() {
        this.currentStep = 1
      },
      // 点击更多信息
      moreInfo() {
        this.currentStep = 2
      },
      // 点击基础信息
      basisInfo() {
        this.currentStep = 0
      },
      // 点击上一步
      handdlePre() {
        this.currentStep = this.currentStep - 1
        if (this.currentStep === 0) {
          this.currentStep = 0
        }
      },
      // 点击下一步
      handdleNext() {
        this.currentStep = this.currentStep + 1
        if (this.currentStep === 2) {
          this.currentStep = 2
        }
      },
      // 商品详情
      getDetail(id) {
        this.$axios.fetchGet(api.archives.goodsInfo + '?id=' + id, {}).then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.$refs.goodsImageUrl.dealFileData(res.data)
              this.$refs.onlineImgMapList.dealFileData(res.data)
              this.addForm = this.$utils.deepClone(res.data)
              if (!this.addForm.father) { // 若father为0，则为普通商品
                this.addForm.openCombination = 0
              }
              //定义选择商品参数
              if (this.addForm.openCombination === 1) {
                this.otherParam.sonGoodsType = 1
              } else if (this.addForm.openCombination === 2) {
                this.otherParam.sonGoodsType = 2
              } else {
                this.otherParam.sonGoodsType = null;
              }
              if (res.data.storeLists && this.storeList.length === res.data.storeLists.length) {
                this.storeChecked = true
              } else {
                this.storeChecked = false
              }
              this.changeLowerPrice(res.data.lowestPrice)
              this.oldData = this.$utils.deepClone(res.data)
            }
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
        })
      },
      // 编辑 商品弹框
      editInfo(row) {
        this.isShowinventoryNum = false;
        this.scopeRow = row
        this.dialogTitle = '编辑'
        this.getDetail(row.id);
        this.addInfoShow = true
        this.isEdit = true
        // 条码是否可编辑
        if (!this.settingInfo.changeBarCode) {
          this.isEditCode = true
        } else {
          this.isEditCode = false
        }
        // 是否允许在商品档案中调价
        if (this.settingInfo.goodsAdjustPrice) {
          this.isEditPrice = false
        } else {
          this.isEditPrice = true
        }
      },
      // 新增 商品信息弹框
      addInfo() {
        // 新增显示初始化库存
        this.isShowinventoryNum = true;
        this.dialogTitle = '新增'
        this.addInfoShow = true
        this.isSyncStore({storeChecked: true})// 默认选择全部门店
        this.isEdit = false
        this.isEditCode = false
        this.isEditPrice = false
        if (this.settingInfo.automaticCode) { // 自编码自动生成
          this.isSubstring = true// 自编码自动截取 为true
          let value
          switch (this.settingInfo.artNoLength) {
            case 10:
              value = 6
              break;
            case 20:
              value = 7
              break;
            case 30:
              value = 8
              break;
            case 40:
              value = 9
              break;
            case 50:
              value = 10
              break;
            default:
              break;
          }
          this.substringLength = value
        } else {
          this.isSubstring = false// 自编码自动截取 为false
        }
      },

      // 关闭新增商品
      closeDialogAdd() {
        this.num = 0
        this.specsForm = null
        this.specsRow = null
        this.$refs.goodsImageUrl.clearData()// 清空图片上传
        this.$refs.onlineImgMapList.clearData()
        this.addInfoShow = false
        this.currentStep = 0
        this.$refs.addForm.resetFields()
        this.addForm = {
          barCode: '', // 条码
          artNo: '', // 自编码
          name: '', // 名称
          goodsAbbreviate: '', // 简称
          mnemonicCode: '', // 助记码
          specs: '', // 规格
          goodsCategoryId: '', // 类别
          goodsBrandId: '', // 品牌
          goodsUnitId: '', // 单位
          goodsImageUrl: '', // 主图
          onlineImgMapList: [], // 详情图
          buyPrice: undefined, // 进货价
          guidePrice: undefined, // 指导价
          retailPrice: undefined, // 零售价
          tradePrice: undefined, // 批发价
          deliveryPrice: undefined, // 配送价
          lowestPrice: 0, // 最低售价
          inventoryNum: 0, // 初始库存
          vipPrice: undefined, // 会员价
          openMall: false, // 商城销售
          onlineImgUrl: '', // 图片链接
          mallRetailPrice: undefined, // 商城零售价
          mallVipPrice: undefined, // 商城会员价
          mallPlusVipPrice: undefined, // 商城PLUS价
          mallLowestPrice: 0, // 商城最低价
          supplierId: '', // 供应商
          manageType: 1, // 经营方式
          buySpecs: '1', // 进货规格
          purchaseCycle: '', // 采购周期
          jointOperationRate: '', // 联营扣率
          openSpecs: false, // 是否多规格
          openCombination: 0, // 商品类型 0普通商品 1组合商品 2自动转货
          father: false, // true的时候就是属于大商品，然后可以编辑子商品
          placeOrigin: '', // 产地
          goodsLevel: '', // 等级
          status: 10, // 商品状态
          pricingMethod: 10, // 计价方式
          openInventory: true, // 是否开启管理库存
          lowInventory: 0, // 库存低位
          highInventory: 9999, // 库存高位
          promotion: '', // 允许促销
          bargaining: true, // 允许议价
          offlineDiscount: true, // 允许折扣
          give: true, // 允许赠送
          guiderCommissionType: 20, // 提成方式,默认按比例
          commissionPercentage: 0.00, // 提成率
          commissionMoney: '', // 提成金额
          syncStore: true, // 是否同步至门店
          storeLists: [], // 门店
          sonVoList: [], // 组合子商品
          businessType: 10,
          combinationType: 20, // 20捆绑销售 30自动转货
          asGoodsSpecsMapList: [], // 多规格列表

          vipDiscount: false, // 会员折扣生成
          onlineDiscount: false, // 线上折扣
          deliveryType: '', // 配送模式
          joinDelivery: '', // 加盟配送
          openVipPrice: false, // 是否开启会员价
          openPlusPrice: false, // 是否Plus会员价
          plusVipPrice: null, // 输入Plus会员价
          isFreshGoods: false, // 生鲜商品
          nissiGoods: false, // 日清商品
          squeezeGoods: false, // 鲜榨商品
          highValueGoods: false, // 高值商品
          takeStockGoods: false, // 交班盘点
          manageSerialNumber: '', // 管理串号
          goodsProduceTime: '', // 生产日期
          qualityGuaranteePeriod: ''// 保质期
        }
      },
      // 输入提成率
      changeCommissionRate(val) {
        if (val > 1 || val < 0) {
          this.$message({message: '提成比例区间是 0.00-1.00', type: 'warning'});
          this.addForm.commissionPercentage = 0.00;
        }
      },
      // 关闭上传弹框
      closeUpload() {
        this.showUpload = false
        this.$refs.importTemplate.reset()
      },
      // 关闭弹框
      closeDialog() {
        this.productCode = ''
        this.listShow = false
        // this.$refs.goodsSync.searchClear()
      },
      selectSubmit() {
        this.$axios.fetchPost('/api/eros/as/asGoods/batch/update', {asGoodsList: this.batchUpDateList}).then(data => {
          if (data.code === 200) {
            if (data.data === true) {
              this.$refs['goodsInfo'].operationSuccess()
            }
          }
        })
      },

      changeGoodsSubmit(param) {
        param.asGoodsList = this.$refs.goodsInfo.getTableSelectRow();
        param.asGoodsList.map(v => {
          Object.keys(v).forEach((key) => {
            if (v[key] === '--') {
              v[key] = null
            }
          })
        });
        this.$axios.fetchPost(api.archives.batchUpDate, param).then(data => {
          if (data.code === 200) {
            this.$refs['goodsInfo'].operationSuccess();
            this.$message({message: '修改成功', type: 'success'});
          } else {
            this.$message({message: '修改失败', type: 'erros'});
          }
          this.$refs['addForm'].clearForm()
        });
      },
      // 批量新增
      batchAddData() {
        this.batchAddShow = true
      },
      // 改变管理库存
      changeOpenInventory(val) {
        if (!val) {
          this.$confirm('此商品不维护库存，其相应的库存记录将被删除，是否确定?', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).catch(() => {
            this.addForm.openInventory = true;
          })
        }
      },

      setSpecs(row) {
        if (row.pricingMethod === 30) {
          this.$confirm('当前商品不允许设置规格', {
            confirmButtonText: '确定',
            type: 'warning'
          })
        } else {
          this.specsDialog = true;
          this.specsRow = row;
        }
      },
      // 主图片上传成功
      setImageData(formModel, fileList) {
        this.addForm.goodsImageUrl = fileList.length > 0 ? fileList[0].response : '';
      },
      setImageOnline1(formModel, fileList) {
        this.addForm.onlineImgMapList = [];
        fileList.forEach(v => {
          this.addForm.onlineImgMapList.push({imageUrl: v.response})
        })
      },
      setImageOnline(formModel, fileList) {
        formModel.onlineImgMapList = [];
        for (let i = 0; i < fileList.length; i++) {
          let objectAdaptor = {
            imageUrl: fileList.length > 0 ? fileList[i].response : ''
          }
          formModel.onlineImgMapList.push(objectAdaptor);
        }
      },
      // 一品多码弹窗
      setBarCode(data, param) {
        console.log(data)
        this.currentBarCodePro = data
        this.page.pageSize = this.$utils.getDataByKey(this.$utils.localStorageKeys.pageSize) || 10;
        let searchParam = {
          pageNumber: this.currentBarCodePageNo,
          pageSize: this.page.pageSize
        };
        // Object.assign(searchParam, {goodsId: data.id});
        Object.assign(searchParam, {barCode: data.barCode});
        this.$axios.fetchPost(api.archives.goodsBarCode + '/page', searchParam).then(data => {
          this.codeTableData = data.data.records
          this.barCodeTotal = data.data.total
          this.page = this.$refs['goodsCode'].page;
          this.$refs['goodsCode'].tableData = data.data.records;
          this.$refs['goodsCode'].page.total = data.data.total;
        });
        this.tableData.param.goodsId = data.id
        this.dialogBarCode = true;
      },
      // 小包装商品弹窗
      setGoods() {
        this.dialogGoods = true;
        this.$axios.fetchPost(api.archives.goodsUnit + '/list').then(data => {
          data.data.map((item) => {
            this.newitem.push(item.name)
          })
        })
      },
      // 水果分级弹窗
      setFruit() {
        this.dialogFruit = true;
      },
      // 生鲜分割弹窗
      setFresh() {
        this.dialogFresh = true;
      },
      // 一品多码添加条码
      add() {
        // let reg = /[A-Z0-9a-z_-]+$/;
        const reg = /^[a-zA-Z0-9-_]+$/;
        console.log(this.productCode);
        if (!reg.test(this.productCode.trim())) {
          this.$message({type: 'warning', message: '附加码只能是数字、字母、中划线(-)、下划线(_)'});
          // this.$message.warning('条码只能是数字、字母、中划线(-)、下划线(_)');
          this.productCode = '';
          return;
        }
        if (this.currentBarCodePro.barCode === this.productCode) {
          return this.$message.warning('附加码不能等于主码！')
        }
        // 验证商品附加码是否存在
        // verifyBarCode
        const getParam = {
          merchantId: this.currentBarCodePro.merchantId,
          barCode: this.currentBarCodePro.barCode,
          code: this.productCode
        }
        this.$axios.fetchGet(api.archives.verifyBarCode, getParam).then(res => {
          // 若为false则允许添加否则提示已存在
          if (res.data !== null && !res.data) {
            this.$axios.fetchPost(api.archives.goodsBarCode, getParam).then(res => {
              // this.$message({
              //   type: 'success',
              //   message: '添加成功'
              // });
              this.$notify({
                type: "success",
                title: '添加操作',
                message: '成功',
                showClose: false,
              });
              this.productCode = ''
              this.setBarCode({barCode: this.currentBarCodePro.barCode})
            })
          } else {
            if (res.errorMsg) return this.$message.error(res.errorMsg)
            return this.$message.warning('当前附加码已存在')
          }
        })
        // goodsInsertBarCode
        // this.$axios.fetchPost(api.archives.goodsInsertBarCode, {
        //   barcode: this.productCode,
        //   goodsId: this.tableData.param.goodsId
        // }).then(data => {
        //   this.$refs['goodsCode'].getTableData();
        //   this.productCode = ''
        // })

      },
      // 小包装商品增加按钮
      minadd() {

      },
      // 小包装商品货号失去焦点
      getMinMes(data) {
        this.$axios.fetchPost(api.archives.goodsInfo + '/list').then(data => {
          console.log(data)
        })
        console.log('失去焦点')
      },
      // 水果分级增加按钮
      fruitadd() {
      },
      // 水果分级商品货号失去焦点
      getFruitMes() {
        console.log('发请求')
      },
      // 生鲜分割增加按钮
      freshadd() {
      },
      // 生鲜分割商品货号失去焦点
      getFreshMes() {
        console.log('失去焦点')
      },
      // 一品多码删除按钮
      finished() {
        let tableRows = this.$refs['goodsCode'].getTableSelectRow();
        tableRows.map(item => {
          let id = item.id;
          this.$axios.fetchDelete(api.archives.goodsBarCode, {
            id: id
          }).then(data => {
            if (data.code == 200) {
              this.$refs['goodsCode'].getTableData();
              // this.$message({type: 'success', message: '删除成功!'});
              this.$notify({
                type: "success",
                title: '删除操作',
                message: '成功',
                showClose: false,
              });
            }
          })
        })
      },
      deliveryTypeChange(row) {
        this.$axios.fetchPut(api.archives.goodsInfo, row).then(data => {
          if (data.code === 200) {
            this.loading = false;
            this.$notify({
              type: "success",
              title: '修改操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '修改成功', type: 'success'});
          } else {
            this.$message({message: '修改失败', type: 'error'});
          }
        }).catch((err) => {
          this.loading = false;
          this.$message({message: '修改失败', type: 'error'});
        });
      },
      export() {
        let params = this.$refs['goodsInfo'].getSearchParams();
        params.exportCode = 'goodsInfoExport';
        this.$axios.fetchPost(api.archives.goodsExport, params).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
            this.loadingExt = false;
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '导出成功', type: 'success'});
          } else {
            this.$message({message: '导出异常', type: 'error'});
          }
        })
      },
      downloadTemplate() {
        this.$axios.fetchPost(api.archives.downloadTemplate, {}).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
            this.loadingExt = false;
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '导出成功', type: 'success'});
          } else {
            this.$message({message: '导出异常', type: 'error'});
          }
        })
      },
      batchDelete() {
        let goodsList = this.$refs.goodsInfo.getTableSelectRow();
        let ids = [];
        if (goodsList.length === 0) {
          this.$message({message: '请勾选数据后进行批量删除！', type: 'warning'});
        } else {
          goodsList.map(v => {
            Object.keys(v).forEach((key) => {
              if (v[key] === '--') {
                v[key] = null
              }
            })
            ids.push(v.id);
          });
          this.$confirm('确定删除选择的商品?', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.$axios.fetchPost(api.archives.batchDelete, {asGoodsList: goodsList, ids: ids}).then(data => {
              if (data.code === 200) {
                this.$notify({
                  type: "success",
                  title: '批量删除操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '批量删除成功!', type: 'success'});
                this.$refs.goodsInfo.$refs.tableTemp.getTableData()
              } else {
                this.$message({message: '批量删除失败!', type: 'error'});
              }
            });
          });
        }
      },
      goodsCategory(data) {
        let goodsCategory = this.changePwdDialog.columns.filter(item => item.prop === 'goodsCategoryId')[0];
        let goodsBrand = this.changePwdDialog.columns.filter(item => item.prop === 'goodsBrandId')[0];
        let unit = this.changePwdDialog.columns.filter(item => item.prop === 'unitName')[0];
        let supplier = this.changePwdDialog.columns.filter(item => item.prop === 'supplierId')[0];
        goodsBrand.isShow = false;
        goodsCategory.isShow = false;
        unit.isShow = false;
        supplier.isShow = false;
        data.orderMes.map(order => {
          if (order === 'goodsBrandId') {
            goodsBrand.isShow = true;
          } else if (order === 'goodsCategoryId') {
            goodsCategory.isShow = true;
          } else if (order === 'supplierId') {
            supplier.isShow = true
          } else if (order === 'unitName') {
            unit.isShow = true;
          }
        });
      },
      // 判断文件类型
      isExcellType(ext) {
        return ['xls', 'xlsx'].indexOf(ext.toLowerCase()) !== -1;
      },
      importFile() {
      },
      openImport() {
        this.importShow = true;
      },
      // 导入
      uploadExcel() {
        // this.showUpload = true
        this.$confirm('只能上传.xls/.xlsx文件，且上传大小不能超过 0.5MB!确认？')
          .then(_ => {
            this.$utils.uploadFile((file) => {
              this.$nextTick(() => {
                this.$refs['importTemplate'].currentStep = 1;
              });
              let formData = new FormData();
              formData.append('multipartFile', file);
              var index = file.name.lastIndexOf('.');
              var ext = file.name.substr(index + 1);
              if (!this.isExcellType(ext)) {
                this.$message.warning('只能上传.xls/.xlsx文件!')
              } else if (file.size > 1024 * 1024 * 0.5) {
                this.$message.warning('上传文件大小不能超过 0.5MB!')
              } else {
                const loading = this.$loading({
                  lock: true,
                  text: '数据导入中，请稍候...',
                  background: 'rgba(225, 225, 225, 0.8)'
                });
                this.$axios.fetchPostGoodsExportBlob(api.archives.goodsImport, formData).then(data => {
                  loading.close();
                  this.$nextTick(() => {
                    this.$refs['importTemplate'].currentStep = 2;
                  });
                  if (data.status === 200) {
                    this.importShow = false;
                    if (data.data.byteLength === 0) {
                      this.$refs['goodsInfo'].operationSuccess();
                    } else {
                      this.$confirm('下载错误数据!确认？')
                        .then(_ => {
                          this.$message({message: '导入成功，请稍后查看', type: 'success'});
                          this.$refs['goodsInfo'].operationSuccess();
                          this.exportErrorData(data);
                        })
                        .catch(() => {
                          this.$message({message: '导入成功，请稍后查看', type: 'success'});
                          this.$refs['goodsInfo'].operationSuccess();
                        })
                    }
                  } else {
                    this.$nextTick(() => {
                      this.$refs['importTemplate'].currentStep = 3;
                    });
                    if (data.errorMsg) {
                      this.$message({message: data.errorMsg, type: 'warning'});
                    } else {
                      this.$message({message: '导入异常', type: 'error'});
                    }
                  }
                }).catch((err) => {
                  this.$refs['importTemplate'].currentStep = 0;
                  loading.close();
                })
                //   .finally(() => {
                //   this.$message({message: '正在导入中,稍后刷新页面查看.', type: 'success'});
                // });
              }
            });
          }).catch(() => {
          this.showUpload = false
        })
      },
      exportErrorData(data) {
        // const elink = document.createElement('a');
        // elink.href = data.data;
        // elink.click();
        // this.loadingExt = false;
        // this.$notify({
        //   type: "success",
        //   title: '错误商品导出操作',
        //   message: '成功',
        //   showClose: false,
        // });
        // this.$message({message: '错误商品导出成功', type: 'success'});

        const fileName = '导入商品错误数据' + '_' + this.$utils.getDateTime() + ".xlsx";
        let blob = new Blob([data.data]);
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        this.$notify({
          type: "success",
          title: '导出操作',
          message: '成功!文件名称:' + fileName,
          showClose: false,
        });
      },
      branchPrice(param) {
        this.$axios
          .fetchPost(api.archives.goodsBranchPrice, {barCode: param.barCode})
          .then((data) => {
            if (data.code === 200) {
              this.branchPriceTableData = data.data;
              this.showBox = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
          });
      },
      oenClickSync() {
        this.dialogOneClickSync = true;
        let params = {};
        params.pageSize = this.oneClickSyncSize;
        params.pageNumber = this.currentoneClickSyncSizePageNo;
        this.getStorePage(params);
      },
      closeDialogOneClickSync() {
        this.dialogOneClickSync = false;
        this.oneClickSyncSize = 10;
        this.currentoneClickSyncSizePageNo = 1;
        this.oneClickSyncTotal = 0;
        this.storeRowArray = [];
      },
      changeOneClickSyncPage(val) {
        let params = {};
        params.pageSize = this.oneClickSyncSize;
        params.pageNumber = val;
        this.getStorePage(params);
      },
      getStorePage(params) {
        this.$axios.fetchPost(api.store.store + '/sync/store/page', params).then(data => {
          if (data.code === 200) {
            this.oneClickSyncTotal = data.data.total;
            if (data.data.records.length > 0) {
              data.data.records.map(e => {
                if (e.storeClass === 1) {
                  e.storeClassName = '直营店';
                } else if (e.storeClass === 2) {
                  e.storeClassName = '加盟店';
                }
              })
            }
            this.storePageTableData = data.data.records;
          } else {
            this.$message.error("获取门店列表异常")
          }
        })
      },
      handleTableSelectStatus(row) {
        return !row.syncGoods;
      },
      selectRowsChange(row) {
        this.storeRowArray = row;
      },
      //同步商品接口
      oneClickSyncGoods() {
        if (!this.storeRowArray.length > 0) {
          this.$message.warning("请勾选需要同步的门店！");
          return;
        }
        if (this.storeRowArray.length > 5) {
          this.$message.warning("勾选门店数量不能超过5！");
          return;
        }
        this.$loading({text: "正在加速同步，请稍候..."});
        let storeIdArr = [];
        this.storeRowArray.map(e => {
          storeIdArr.push(e.id);
        })
        let params = {};
        params.storeLists = storeIdArr;
        //开始同步
        this.$axios.fetchPost(api.archives.goodsInfo + "/sync/goods", params).then(data => {
          if (data.code === 200 && data.data === 'SUCCESS') {
            this.$message.success("商品正在同步，请稍后进入门店查看");
          } else {
            this.$message.error(data.errorMsg ? data.errorMsg : "商品同步失败");
          }
        }).finally(() => {
          //关闭窗口
          this.$loading().close();
          this.closeDialogOneClickSync();
        })
      }
    }
  };
</script>

<style scoped>
  .setCode {
    padding: 10px 30px;
    box-sizing: border-box;
  }

  .setCode .button {
    display: flex;
    width: 100%;
    align-items: center;
    margin-bottom: 20px;
  }

  .setCode >>> .el-table__row {
    height: 35px;
  }

  .little-data >>> .list-operation {
    width: 63%;
    max-height: 300px;
    overflow-y: auto;
  }

  .little-data {
    display: flex;
    justify-content: space-between;
  }

  .batchAdd {
    max-height: 420px;
    overflow-y: auto;
  }

  .little-data img {
    width: 38%;
    height: 40%;
  }

  .inputsearch {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding-left: 30px;
  }

  .inputsearch .searc {
    width: 42%;
    margin-bottom: 20px;
  }

  .priceEdit {
    margin-left: 10px;
    margin-bottom: 20px;
  }

  .upload-self >>> .el-upload.el-upload--text {
    border: none;
    height: auto;
    line-height: unset;
  }

  .dialog-style >>> .el-dialog {
    min-width: 600px;
  }

  .form-flex {
    display: flex;
    flex-direction: column;
  }

  /*新增档案表单*/
  .steps-form {
    padding: 0 50px;
    min-height: 500px
  }

  .footer {
    display: flex;
    justify-content: center;
    /*padding-bottom:20px;*/
  }

  .button-gray {
    /*background-color: #dcdcdc;*/
    border-color: #d8d8d8;
    color: #999;
  }

  .add-form {
    /*overflow: hidden;*/
    /*top:-7vh;*/
    /*height:80vh;*/
    /*max-height: unset;*/
  }

  .add-form >>> .el-dialog {
    max-height: 90vh;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
  }

  .add-form >>> .el-dialog__body {
    max-height: unset;
  }

  .add-form >>> .el-form-item {
    min-height: 35px;
  }

  >>> .el-input__inner {
    height: 30px;
  }

  .add-form >>> .el-form-item .el-cascader {
    line-height: unset;
  }

  .store-checkbox {
    text-align: right;
    width: 100%;
    padding-right: 10px;
  }

  >>> .el-dialog__header {
    margin-bottom: 10px;
  }

  >>> .el-select__tags .el-tag.el-tag--info {
    padding-right: 18px;
    max-width: unset;
  }

  >>> .el-tag.el-tag--info .el-tag__close {
    right: 1px;
  }

  .cus-steps >>> .el-step__title.is-process {
    color: #369afe;
    font-weight: 900;
  }

  .cus-steps >>> .el-step__head.is-process {
    border-color: #369afe;
  }

  .cus-steps >>> .el-step__head.is-process .el-step__icon.is-text {
    color: #fff;
    background-color: #369afe;
  }

  >>> .good-list {
    height: 600px !important;
  }

  >>> .specs-info-component {
    height: 600px !important;
    overflow-y: auto;
  }

  >>> .list-operation {
    height: 400px !important;
    padding-bottom: 0px;
    overflow-y: auto;
  }

  /*>>>.list-operation .list-operation-table{*/
  /*  max-height: unset !important;*/
  /*  height:100% !important;*/
  /*}*/
  .batch-form >>> .el-form-item {
    min-height: auto;
    line-height: 40px;
  }

  >>> .el-cascader {
    line-height: unset;
  }

  .checkbox-style >>> .el-checkbox {
    display: flex;
    align-items: center;
  }

  .checkbox-style .form-item-select >>> .el-select {
    width: 100px;
  }

  .checkbox-style >>> .el-form-item__label {
    line-height: 35px;
  }

  .checkbox-style >>> .el-col {
    display: flex;
  }

  .steps-form >>> .el-input-number .el-input__inner {
    padding: 0 10px;
    text-align: left;
  }

  .checkbox-style >>> .el-input-number .el-input__inner {
    padding: 0 10px;
    text-align: left;
  }

  /*去掉箭头*/
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  /deep/ input[type="number"] {
    -moz-appearance: textfield;
  }

  /deep/ .barCodeDialog {
    min-width: 500px;
  }

  .info-text {
    margin-top: 34px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #E8A462;
    background: #FDF6EC;
    padding: 13px 18px;
  }

  .syncGoods /deep/ .is-active {
    background: #458CFF !important;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }

  .fond-style {
    color: #ffad39;
    font-size: 13px;
    font-weight: 600;
    line-height: 22px;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Info.vue